import type { Release } from '../releases';

/**
 * Записи «Что нового» до 01.11.2026, когда все чаты писали в один файл. Новые сверху, порядок ручной — так их показывает
 * страница. Этот список больше не пополняется: новая запись — свой файл рядом (releases/<id>.ts), см. releases.ts.
 */
export const RELEASES_ARCHIVE: Release[] = [
  {
    id: '2026-10-31-project-attention',
    at: '2026-11-01T04:42:00Z',
    title: 'В проекте — всё, что требует внимания, из всех разделов',
    modules: ['portfolio'],
    items: [
      'На вкладке «Обзор» проекта блок «Требует внимания» собирает дела и находки всех разделов: график, склад, площадка, закупки, договоры, оплаты, письма, изменения, бюджет, ПСД и ресурсы. У каждой строки — кнопка, которая ведёт прямо в запись раздела; когда дело сделано, строка исчезает сама.',
      'Строки можно отфильтровать по разделу; просроченное — сверху. Видны только разделы, к которым у вас есть доступ, суммы — по вашему уровню денег.',
      'Там же и на вкладках «ПСД» и «Ресурсы» — короткие сводки: комплекты в производстве, просроченные и в карантине, открытые вопросы и замечания; сколько людей и машин нужно на этой неделе и каких профессий не хватает.',
    ],
    why: 'Руководителю приходилось обходить разделы по одному, чтобы понять, что горит на проекте: блок показывал только часть находок, без площадки, склада и документов.',
    link: '/projects',
  },
  {
    id: '2026-10-31-site-photos-links',
    at: '2026-11-01T04:42:00Z',
    title: 'Фото и видео площадки — к работе, листу и замечанию, без дублей и без места в файле',
    modules: ['site'],
    items: [
      'Фото и видео отчёта смены хранятся с привязкой к работе графика, листу ПСД и замечанию. Новая страница «Фото площадки» показывает их по работе, листу или замечанию.',
      'Проверяющий видит фото и видео в отчёте у каждой работы и может открыть файл. Отчёт с фото принимается, когда все файлы загружены и проверены антивирусом.',
      'Если связь оборвалась во время отправки, телефон не загружает фото второй раз, а берёт уже принятый файл. Тот же снимок второй раз в отчёт не добавляется.',
      'Место съёмки из файлов фото и видео удаляется всегда; с согласия оно хранится только в записи отчёта. Согласие можно отозвать кнопкой у снимка.',
    ],
    why: 'Фото отчёта нельзя было найти из работы, листа или замечания, проверяющий их не видел и не мог принять отчёт с фото, а при обрыве связи на сервере оставались лишние копии файлов.',
    link: '/site/photos',
  },
  {
    id: '2026-10-31-three-offers-split',
    at: '2026-10-31T09:57:00Z',
    title: 'Порог трёх КП и возможное дробление видно до решения',
    modules: ['procurement', 'contracts'],
    items: [
      'В карточке заявки на сборе КП, анализе и согласовании — блок «Правило трёх КП»: порог компании, сумма по смете или по выбранному КП, сколько КП есть и заполнено ли обоснование. Видно до перехода, а не только отказом.',
      'Порог трёх КП задаёт администратор: «Администрирование → Настройки», рядом с окном проверки дробления. По умолчанию 300 000 ₸.',
      'Возможное дробление закупки видно ещё до выбора поставщика — для каждого КП, — и после выбора до согласования. В заявке и в договоре — ссылки на сходные договоры и заявки того же поставщика. Суммы — только с уровнем денег; закупки проектов, к которым нет доступа, показаны числом.',
    ],
    why: 'Снабженец узнавал о нехватке трёх КП только отказом при переходе, а признаки дробления — уже после выбора поставщика; порог был зашит в портал и не менялся под регламент компании.',
    link: '/procurement',
  },
  {
    id: '2026-10-31-schedule-speed',
    at: '2026-10-31T09:57:00Z',
    title: 'Большой график пересчитывается и правится быстрее',
    modules: ['schedule'],
    items: [
      'Пересчёт графика на 10 000 работ — примерно вдвое быстрее: сохраняются только даты, которые изменились.',
      'После правки работы страница получает с сервера только изменённые работы и связи, а не весь график заново.',
    ],
    why: 'На больших графиках пересчёт и каждая правка шли по 3–5 секунд: сервер каждый раз перечитывал и пересылал весь график.',
    link: '/schedule',
  },
  {
    id: '2026-10-31-estimate-20000-items',
    at: '2026-10-31T09:57:00Z',
    title: 'Большая смета открывается сразу: разделы подгружаются, есть поиск позиций',
    modules: ['estimates'],
    items: [
      'Смета на 20 000 позиций открывается за доли секунды: сначала шапка и разделы с итогами, позиции раздела — по 200, по кнопке «Показать ещё». Раздел раскрывается и сворачивается нажатием на его название, рядом — число позиций.',
      'Над позициями — поиск: по коду (свой или локальный), номеру позиции и словам наименования, например «арматура» или «1101-02».',
      'Итоги разделов хранятся и пересчитываются сразу при правке, удалении и загрузке позиций, суммы те же, что раньше. Без доступа к суммам они скрыты, в том числе в истории изменений раздела.',
    ],
    why: 'Раньше смета грузилась целиком одним ответом: на 20 000 позициях экран открывался почти две секунды и дольше, а найти позицию можно было только прокруткой.',
    link: '/estimates',
  },
  {
    id: '2026-10-31-help-every-page',
    at: '2026-10-31T09:39:00.000Z',
    title: 'Помощь к каждой странице и поиск по «Что нового»',
    modules: ['whatsnew', 'support'],
    items: [
      'Кнопка «Помощь» теперь на каждой странице показывает инструкцию для вашей роли: что делают в разделе, что есть на этой странице (например, «Мой день», письма, вкладки администрирования) и что вам доступно по правам.',
      'Если администратор выбрал для срока в форме пункт регламента, в «Помощи» появляется блок «Подсказки полей»: что это за срок и на какой пункт он опирается.',
      'В «Что нового» появился поиск: по слову из заголовка, пунктов или пояснения, зачем это сделано. У записей видно «Зачем» и ссылку «Где посмотреть». Записи о разделах, закрытых вам, не показываются и в поиске.',
    ],
    why: 'Раньше у многих страниц в «Помощи» было только общее описание раздела, а нужную запись в «Что нового» приходилось искать, листая всю историю.',
    link: '/whats-new',
  },
  {
    id: '2026-10-26-section-permissions',
    at: '2026-10-31T03:09:00.000Z',
    title: 'Отдельные права: видео, база знаний, поддержка, персональные данные, отчёты',
    modules: [],
    items: [
      'В «Ролях и правах» появились свои права у видеонаблюдения, базы знаний, поддержки и конструктора отчётов, а также право «Видеть персональные данные работников». Доступ ни у кого не пропал: роли получили новые права по тем, что у них уже были.',
      'Номер удостоверения и кем выдано, сканы допусков видны только с правом на персональные данные. Остальные видят вид допуска и срок.',
      'В меню — «Списки» и «Техника». На главной — кнопка «Сообщить об опасности» для каждого сотрудника.',
    ],
    why: 'Видео, база знаний, поддержка и отчёты работали на чужих общих правах: нельзя было дать человеку доступ к одному разделу, не открыв ему другой, а персональные данные работников видел каждый, кто ведёт охрану труда.',
    link: '/admin/roles',
  },
  {
    id: '2026-10-27-site-aosr-report-photos',
    at: '2026-10-31T03:09:00.000Z',
    title: 'Площадка: фото отчёта в вызове на скрытые работы',
    modules: ['site', 'supervision'],
    items: [
      'При вызове на освидетельствование из проверки отчёта смены фото этой работы можно сразу приложить к акту — надзору не нужно искать их в отчёте.',
    ],
    why: 'Прорабу приходилось искать фото работы в отчёте смены и прикладывать их к акту на скрытые работы вручную, а надзор видел акт без фото.',
    link: '/site',
  },
  {
    id: '2026-10-29-member-card',
    at: '2026-10-31T02:47:00.000Z',
    title: 'Карточка пользователя в администрировании',
    modules: ['admin'],
    items: [
      'Администрирование → «Сотрудники» → имя человека: открывается его карточка. Слева — логин, ФИО, должность, телефон, карточка работника в учёте персонала, организация подрядчика, подключён ли Telegram, роли с объектами доступа и уровень денег с пояснением, что он видит. Всё сохраняется одной кнопкой.',
      'Справа — действия с пояснениями: выдать новый пароль (ссылка на почту), отправить приглашение заново, письмо с доступом (адрес портала, логин, роли и «С чего начать», без пароля), состояние входа, заблокировать вход с причиной и удалить пользователя из компании — его записи и подписи остаются с его именем.',
      'Найти человека можно и через поиск (Ctrl+K) — по имени или почте.',
    ],
    why: 'Раньше данные человека и действия с ним были разбросаны по окну правки, списку приглашений и кабинету портала; теперь всё на одной странице, как администраторы привыкли.',
    link: '/admin/members',
  },
  {
    id: '2026-10-30-estimate-version-on-approval',
    at: '2026-10-30T04:35:00.000Z',
    title: 'Новая версия сметы создаётся сама при утверждении запроса на изменение',
    modules: ['estimates'],
    items: [
      'Когда запрос на изменение утверждён, утверждённая текущая смета, привязанная к нему, сама копируется в новую версию-черновик: разделы, позиции, ресурсы, коэффициенты и связи с ПСД и графиком. В версии записаны причина и номер запроса.',
      'Сметчик получает поручение внести правки в новую версию. Прежняя версия остаётся в истории без изменений, повторное утверждение копию не дублирует.',
    ],
    why: 'Раньше после утверждения запроса сметчик сам делал копию сметы для правок: это легко забыть, и тогда правки попадали в утверждённую версию.',
    link: '/estimates',
  },
  {
    id: '2026-10-28-warranty-ratings',
    at: '2026-10-29T09:35:00.000Z',
    title: 'Гарантийные обращения заказчика и оценки поставщиков',
    modules: ['contracts', 'suppliers'],
    items: [
      'В карточке договора с заказчиком появились «Гарантийные обращения»: что случилось, срок ответа заказчику (по умолчанию 2 дня) и срок устранения (14 дней), фото и акты, расходы на устранение. Когда срок подходит или прошёл, обращение приходит в «Ждёт меня» ответственному.',
      'К обращению можно привязать договор поставщика или подрядчика того же проекта: сразу видно, до какой даты у него действует гарантия.',
      'В карточке договора появились «Оценки» от 1 до 5 с комментарием: заказчик оценивает нашу работу, а снабженец, кладовщик и прораб — поставщиков и подрядчиков, в том числе каждую поставку на склад. Средняя оценка контрагента считается по всем договорам. Оценка 3 и ниже сразу уходит руководителю проекта поручением и оповещением; без комментария такая оценка не принимается.',
    ],
    why: 'Сроки ответа заказчику после сдачи объекта и плохие поставки терялись в письмах: теперь они на виду, а руководитель проекта узнаёт о низкой оценке сразу.',
    link: '/contracts',
  },
  {
    id: '2026-10-28-datalog',
    at: '2026-10-29T09:35:00.000Z',
    title: 'Журнал изменений: отмена, восстановление удалённого, проверка базы',
    modules: ['admin'],
    items: [
      'Администрирование → «Журнал изменений»: каждое действие сотрудников — кто, когда, с какого устройства и что изменил, «было → стало». Отбор по сотруднику, разделу, проекту, дате и тексту, выгрузка в Excel.',
      'Любое действие можно отменить с причиной: портал сначала пробует отмену в базе и показывает, что изменится. Отменяется всё действие целиком вместе со связанными записями; если записи потом меняли ещё раз — только вместе с этими изменениями. Статусы и подписи меняются только действием в своём разделе, суммы — только тем, кто их видит.',
      'Удалённые договоры, заявки, контакты и другие записи — на вкладке «Удалённое», кнопка «Восстановить» возвращает их вместе со всем, что удалилось вместе с ними. Отмену тоже можно отменить.',
      'У любой записи — история и состояние на любую дату с кнопкой «Вернуть запись к этому состоянию»: из журнала или из «Истории» в карточке.',
      'После каждой отмены и каждую ночь портал проверяет базу; журнал хранится 3 года и каждые сутки запечатывается — правку задним числом видно. Отменять может тот, у кого в роли есть право «Отменять изменения из журнала».',
      'Владельцу портала — вкладка «Версии»: история выкладок и возврат на прошлую версию портала или обратно с проверкой совместимости базы, копия базы перед миграцией.',
    ],
    why: 'Ошибочное изменение или удаление нельзя было вернуть — только ввести заново по памяти, а кто, когда и что поменял, было видно лишь в истории одной записи. Возврат на прошлую версию портала делался вручную.',
    link: '/admin/audit',
  },
  {
    id: '2026-10-28-platform-console',
    at: '2026-10-29T09:35:00.000Z',
    title: 'Вход в портал под защитой от подбора пароля и объявления команды портала',
    modules: [],
    items: [
      'Защита от подбора пароля: после пяти неверных паролей вход по этой почте с незнакомых устройств закрывается на 15 минут (при повторе — на час, затем на шесть часов), и верный пароль в это время тоже не пускает. На своём телефоне или компьютере, где вы уже входили, чужие попытки вас не запрут. Если заблокировало — подождите, задайте новый пароль по ссылке «Забыли пароль?» (блокировка снимется сразу) или попросите администратора портала снять блокировку.',
      'Команда портала может сообщить о работах на портале или новых разделах: объявление появится полосой вверху страницы, «Скрыть» убирает его у вас. Важные объявления — жёлтые.',
    ],
    why: 'Пароль можно было подбирать без ограничений, а о работах на портале команда портала могла сообщить только письмом вне портала.',
    link: '/',
  },
  {
    id: '2026-10-28-platform-console-admin',
    at: '2026-10-29T09:35:00.000Z',
    title: 'Команда портала в журнале лицензии компании',
    modules: ['admin'],
    items: [
      'Администрирование → Лицензия → журнал: если команда портала открывала портал вашей компании для поддержки, здесь видно кто, когда, в каком режиме (просмотр или правка) и по какой причине. Изменения, сделанные при этом, — в истории изменений под именем вошедшего.',
      'Там же видно, если владелец портала передал владение компанией другому сотруднику.',
    ],
    why: 'Компания не видела, когда команда портала открывала её портал для поддержки и что при этом меняла.',
    link: '/admin/license',
  },
  {
    id: '2026-10-28-permit-print-stats',
    at: '2026-10-29T09:35:00.000Z',
    title: 'Наряд-допуск: печатная форма с QR и показатели нарядов',
    modules: ['qhse'],
    why: 'Наряд нужно держать на месте работ на бумаге и сверять с порталом, а руководителю — видеть, сколько нарядов ждут подписи, возвращаются и продлеваются.',
    link: '/qhse?tab=permits',
    items: [
      'В карточке наряда — «Печатная форма»: реквизиты, меры, риски, изоляции, анализ воздуха, бригада, подписи и отпечаток содержания. QR на бумаге открывает наряд в портале — отпечатки должны совпасть.',
      'Если по наряду работать нельзя (черновик, на подписи, остановлен, срок истёк, отменён), это крупно написано на бумаге.',
      'В списке нарядов — показатели за 30 дней, 90 дней или год: время согласования и выполнения, возвраты, продления, превышения в анализе воздуха и остановки работ, всего и по видам работ.',
    ],
  },
  {
    id: '2026-10-28-site-permits-suspended',
    at: '2026-10-29T09:35:00.000Z',
    title: '«Мой день»: остановленные наряды-допуски видны прорабу',
    modules: ['site'],
    items: [
      'В «Мой день» в блоке «Наряды-допуски» теперь видны и наряды, по которым работы остановлены, — с красной отметкой «Работы остановлены». Работа по такому наряду в отчёте смены не открывается, пока охрана труда не возобновит работы.',
      'Какие удостоверения нужны бригаде для вида наряда, план дня теперь берёт из настроек нарядов компании (кнопка «Настройки нарядов» в списке нарядов-допусков).',
    ],
    why: 'Прораб должен видеть, что работы остановлены, а не гадать, почему наряд пропал из списка.',
    link: '/site/day',
  },
  {
    id: '2026-10-28-timesheet-from-reports',
    at: '2026-10-29T05:04:00.000Z',
    title: 'Табель: часы из отчётов смены видны отдельно',
    modules: ['resources', 'site'],
    items: [
      'В табеле раздела «Ресурсы» часы, которые пришли из принятого отчёта смены, отмечены: над таблицей — сколько часов за месяц пришло из отчётов, в подсказке ячейки — сколько именно.',
      'Часы из отчётов входят в факт по работам графика рядом с введёнными вручную.',
    ],
    why: 'Раньше нельзя было отличить часы, пришедшие с площадки, от внесённых руками; теперь видно, что уже подтверждено отчётом.',
    link: '/resources',
  },
  {
    id: '2026-10-28-budget-reconcile',
    at: '2026-10-29T05:04:00.000Z',
    title: 'Сверка бюджета с файлом Excel до тенге',
    modules: ['budget'],
    items: [
      'В проекте на вкладке «Бюджет и маржа» появился блок «Сверка с файлом». Если при загрузке бюджета итог недели в файле не совпал с суммой разделов, портал считает итог по строкам и записывает исправление: неделя, ячейка файла, было → стало — например, ячейка O48: +11 882 000 ₸.',
      'Кнопка «Сверить с файлом»: выберите файл Excel — портал сверит с ним версию бюджета построчно и по неделям до тенге и покажет строки и недели, которые расходятся. Новая версия при этом не создаётся.',
    ],
    why: 'Итоги в файлах бюджета бывают с ошибками формул, а проверить, что портал перенёс файл без потерь, было нечем: теперь каждое исправление видно с суммами «было → стало».',
    link: '/projects',
  },
  {
    id: '2026-10-28-contract-obligations',
    at: '2026-10-28T16:08:00.000Z',
    title: 'Договоры: сроки, уведомления и банковские гарантии',
    modules: ['contracts', 'finance'],
    items: [
      'В карточке договора появились «Сроки и обязательства»: платежи и поставки с ответственным и сроком, повтор на год вперёд одним действием. Срок уведомления (например, 28 дней на извещение о претензии) ждёт события и начинает идти, когда вы отметите, что оно случилось.',
      'Там же — «Обеспечения и гарантии»: банковские гарантии, аккредитивы и гарантийный срок по объекту. За выбранное число дней до окончания придёт напоминание; гарантию можно продлить или отметить возвращённой. Суммы видны только тем, у кого есть доступ к суммам договоров.',
      'Просроченное и ближайшие 30 дней — в «Ждёт меня», ближайшая неделя — в утренней сводке. На странице «Договоры» сверху — сроки и гарантии на год вперёд по месяцам.',
    ],
    why: 'Сроки извещений и гарантий по договорам легко пропустить: пропущенное уведомление или гарантия, о которой забыли, стоят денег, поэтому портал теперь напоминает заранее.',
    link: '/contracts',
  },
  {
    id: '2026-10-28-permit-jsa',
    at: '2026-10-28T16:08:00.000Z',
    title: 'Наряд-допуск: анализ рисков и подпись с отпечатком',
    modules: ['qhse'],
    why: 'Опасности работ не разбирались по шагам, а по подписи нельзя было доказать, какое содержание наряда подписали.',
    link: '/qhse',
    items: [
      'В карточке наряда — анализ рисков по шагам работы: опасность, тяжесть и вероятность от 1 до 5, меры и риск после мер.',
      'С недопустимым риском после мер наряд не отправить на подпись; для огневых и газоопасных работ анализ обязателен (меняется в настройках нарядов).',
      'Каждая подпись ставится под отпечатком содержания наряда: изменённый наряд подписать нельзя, возврат в работу снимает подписи.',
    ],
  },
  {
    id: '2026-10-28-letter-term-hint',
    at: '2026-10-28T14:10:00.000Z',
    title: 'Письма: срок ответа подсказывается из текста; ответное письмо закрывает ожидание',
    modules: ['documents'],
    items: [
      'При регистрации письма кнопка «Найти срок в тексте письма» находит «в течение 5 рабочих дней», «within 10 working days», «5 жұмыс күні ішінде» или названную дату и предлагает срок по календарю РК — вы подтверждаете или правите',
      'Когда вы регистрируете ответное письмо, встречное письмо, которое ждало ответа, само получает статус «Ответ дан»',
    ],
    why: 'Срок ответа в письмах приходилось искать глазами и считать рабочие дни вручную, а ответ приходилось отмечать отдельно.',
    link: '/documents/letters',
  },
  {
    id: '2026-10-28-password-reset',
    at: '2026-10-28T14:03:00.000Z',
    title: 'Забыли пароль — ссылка на почту; «Сбросить пароль» в «Сотрудниках»',
    modules: [],
    items: [
      'На странице входа появилась ссылка «Забыли пароль?»: укажите рабочую почту — придёт письмо со ссылкой, по которой можно задать новый пароль. Ссылка действует один час и срабатывает один раз.',
      'Администратор в «Сотрудниках» открывает карточку человека и нажимает «Сбросить пароль»: портал присылает человеку письмо со ссылкой для нового пароля, она действует сутки. Ссылку видит только сам человек, прежний пароль работает, пока он не задаст новый. Пароль владельца компании сбрасывает только сам владелец.',
      'После смены пароля все сеансы входа завершаются, а на почту приходит письмо «Пароль изменён». Тем, кто входит по Face ID и не помнит пароль, ссылку можно получить и из профиля.',
    ],
    why: 'Кто забыл пароль или входил только по Face ID, сам вернуть вход не мог, а администратор не мог ему помочь: повторное приглашение работающему сотруднику портал не создаёт.',
    link: '/forgot-password',
  },
  {
    id: '2026-10-28-money-by-project',
    at: '2026-10-28T13:45:00.000Z',
    title: 'Доступ к деньгам по проектам',
    modules: ['admin', 'portfolio', 'budget'],
    items: [
      'Владелец компании может открыть человеку суммы только на нужных проектах: Администрирование → Сотрудники → карточка → «Деньги по проектам». Например, общий уровень «Без денег», а на своём проекте — «Все деньги». Можно выбрать проект (вместе с подпроектами), направление или юрлицо; то же — в приглашении.',
      'Суммы этого проекта человек видит в карточке проекта, списке проектов, портфеле, бюджете и оплатах проекта. Итог портфеля по нескольким проектам показывается, только если суммы видны во всех них.',
      'Уровни по проектам видит и меняет только владелец компании. Остальные разделы (договоры, заявки на оплату, финансы, закупки, сметы) пока смотрят на общий уровень и откроются по проектам следующим обновлением.',
    ],
    why: 'Раньше уровень денег был один на человека: руководителю проекта нельзя было открыть суммы его проекта, не открыв все остальные.',
    link: '/admin/members',
  },
  {
    id: '2026-10-28-update-mail-full',
    at: '2026-10-28T12:00:00.000Z',
    title: 'Письма об обновлении: что изменится, зачем и где посмотреть',
    modules: [],
    items: [
      'За 5 минут до обновления владельцы компаний получают предупреждение: что изменится, зачем это сделано и где посмотреть после обновления. Владельцам портала — ещё коммиты, почему перезапускается каждая часть портала и есть ли миграции базы.',
      'В письме «Портал обновлён» у каждой записи теперь есть «Зачем» — какую задачу она решает — и ссылка «Посмотреть» на страницу портала.',
    ],
    why: 'Предупреждение об обновлении называло только время и номер версии: было непонятно, что меняется, зачем и где это увидеть.',
    link: '/whats-new',
  },
  {
    id: '2026-10-28-site-fact-schedule-forecast',
    at: '2026-10-28T11:58:00.000Z',
    title: 'График: факт и прогноз из отчётов смены',
    modules: ['schedule', 'site'],
    items: [
      'Принятый отчёт смены теперь отмечает работу графика начатой с дня смены — раньше объём и процент приходили, а расчёт считал работу не начатой.',
      'Дата отчёта графика сама сдвигается на следующий день после принятой смены: прогноз окончания работ и вех считается от неё. Отчёт за прошлый день, принятый позже, дату назад не возвращает.',
      'Прогноз по выработке («Сценарии» → «Прогноз по выработке») берёт темп из принятых отчётов: сколько в среднем делали за день смены.',
    ],
    why: 'Факт по работам графика вносили вручную, и прогноз расходился с площадкой; теперь график сам берёт факт из принятых отчётов смены.',
    link: '/schedule',
  },
  {
    id: '2026-10-28-resource-statement-excel',
    at: '2026-10-28T11:30:00.000Z',
    title: 'Ресурсная ведомость сметы — в Excel',
    modules: ['estimates'],
    items: [
      'На вкладке «Ресурсы» сметы и на странице ресурсной ведомости проекта появилась кнопка «Ведомость в Excel»: труд, машинисты, машины, материалы и оборудование по группам, внизу итоги.',
      'Если у вас нет доступа к суммам, в файл попадают только количества и трудоёмкость — цен и сумм в нём нет.',
    ],
    why: 'Ресурсную ведомость сметы приходилось собирать вручную; теперь её можно выгрузить в Excel в один клик.',
    link: '/estimates',
  },
  {
    id: '2026-10-28-help-videos',
    at: '2026-10-28T10:04:00.000Z',
    title: 'Видеоинструкции по ролям: сценарии и субтитры',
    modules: [],
    items: [
      'Для каждой роли демо-компании подготовлен сценарий видеоинструкции: какие страницы показать и что сказать в кадре.',
      'Субтитры к ролику можно скачать файлом SRT (список — «Помощь», адрес /support/help/videos).',
      'Когда страница изменилась после записи, ролик помечается устаревшим и его нужно перезаписать.',
    ],
  },
  {
    id: '2026-10-28-company-backups',
    at: '2026-10-28T09:55:00.000Z',
    title: 'Резервные копии компании',
    modules: ['admin'],
    items: [
      'Администрирование → Копии: расписание, число хранимых копий и свои места хранения (до двух).',
      'Копии шифруются ключом вашей компании; скачать копию и получить ключ может только владелец, с повторным вводом пароля.',
      'Кнопка «Сделать копию сейчас» и проверка связи с хранилищем.',
    ],
  },
  {
    id: '2026-10-28-fleet-service-rules-unique',
    at: '2026-10-28T08:19:00.000Z',
    title: 'Техника: регламент ТО не задваивается, удаление спрашивает подтверждение',
    modules: ['resources'],
    items: [
      'Два одинаковых регламента ТО (то же название и та же модель) завести нельзя, даже если нажать «Сохранить» дважды подряд.',
      'Перед удалением регламента ТО портал спрашивает подтверждение: вместе с ним удаляются отметки ТО по нему.',
    ],
  },
  {
    id: '2026-10-28-invite-start-guide',
    at: '2026-10-28T06:23:00.000Z',
    title: 'Приглашение в портал с инструкцией и страница «С чего начать»',
    modules: [],
    items: [
      'Каждый, кого приглашают в портал, получает письмо со ссылкой и инструкцией под свои права: какие разделы ему открыты (со ссылками), что сделать с первого входа — что заполнить и что проверить — и что делать каждый день.',
      'Та же инструкция всегда под рукой: меню пользователя → «С чего начать». Сделанные шаги отмечаются, часть портал отмечает сам — вход по Face ID, экскурсию, уведомления. Инструкцию можно скачать в PDF.',
      'Администратору: после приглашения видно, ушло ли письмо; текст приглашения с инструкцией можно скопировать и отправить в мессенджере, а в списке приглашений есть «Отправить заново» с новой ссылкой — и для приглашений, у которых вышел срок.',
    ],
  },
  {
    id: '2026-10-28-release-mail',
    at: '2026-10-28T06:23:00.000Z',
    title: 'Письмо «Портал обновлён» после каждого обновления',
    modules: ['admin'],
    items: [
      'После обновления портала, в котором есть новое по их разделам, администраторы компании и выбранные сотрудники получают письмо: когда обновился портал, версия и что нового. Администраторам письмо приходит по умолчанию; кому ещё писать — выбранным сотрудникам или всем — администратор задаёт в «Администрирование → Настройки → Письма об обновлении портала»; там же кнопка «Прислать пробное письмо мне».',
      'Утреннюю сводку теперь можно выключить для всей компании, например на время запуска портала: «Администрирование → Настройки → Уведомления сотрудникам».',
    ],
  },
  {
    id: '2026-10-28-pilot-reasoning',
    at: '2026-10-28T06:23:00.000Z',
    title: 'Pilot: своя модель отвечает коротко, без рассуждений',
    modules: ['ai'],
    items: [
      'Своя модель Pilot больше не тратит предел длины ответа на рассуждения: портал выключает их в запросе. После выкладки контрольная проверка модели запустится сама.',
      'Кабинет владельца портала → «Pilot»: у каждого контрольного вопроса видна причина («неверно», «ответ обрезан», «пустой ответ», «модель не ответила») и длина ответа.',
    ],
  },
  {
    id: '2026-10-28-view-as',
    at: '2026-10-28T06:23:00.000Z',
    title: 'Посмотреть портал глазами сотрудника',
    modules: ['admin'],
    items: [
      'Администрирование → Сотрудники → «Глазами»: портал откроется так, как его видит выбранный человек — его меню, разделы, «Ждёт меня» и данные по его правам. Удобно, когда сотрудник пишет «не вижу раздел» или «не могу найти».',
      'Это только просмотр: изменить ничего нельзя, личные настройки человека не показываются, суммы — не больше, чем видите вы сами. Вверху страницы — полоса режима и кнопка «Выйти из режима»; через час режим заканчивается сам.',
      'Кто, кого и когда смотрел — в журнале на той же странице. Включает владелец компании или администратор с правом «Пользователи»; глазами владельца смотрит только владелец.',
    ],
  },
  {
    id: '2026-10-28-fleet-service',
    at: '2026-10-28T06:45:00.000Z',
    title: 'Техника: ТО по моточасам',
    modules: ['resources'],
    items: [
      'В разделе «Техника» появилась вкладка «ТО»: для каждой единицы виден прогноз следующего ТО по наработке из путевых листов за последние 30 дней — сколько моточасов осталось и в какой день ожидается.',
      'Регламент ТО задаёт компания: «ТО-250», «ТО-1000», сезонное — через сколько моточасов или дней, для всей техники или для одной модели. План «единица × месяц» показывает ТО на год вперёд, шкала наработки — прошлые ТО, следующее и счётчик сейчас.',
      'Отметка «ТО выполнено» пересчитывает прогноз. Просроченное и ближайшее ТО приходит в «Ждёт меня» тем, кто ведёт технику; «Заявка на запчасти» создаёт заявку в закупках проекта. Расходы на ТО и ремонт техники проекта видны в «Марже проекта» рядом с остальными фактами.',
    ],
  },
  {
    id: '2026-10-28-permit-loto',
    at: '2026-10-28T06:45:00.000Z',
    title: 'Наряды-допуски: изоляции LOTO, одновременные работы, продление',
    modules: ['qhse'],
    items: [
      'В наряде-допуске — точки изоляции: что отключено и чем (задвижка, заглушка, замок и бирка), номер бирки. Установку отмечает один человек, проверку — другой. Пока все изоляции не проверены, наряд не открыть.',
      'После работ — кнопка «Работы завершены»: ответственный получает дело «Снимите изоляции». Изоляцию нельзя снять, пока идут работы или ту же точку держит другой наряд; наряд не закрывается, пока изоляции стоят.',
      'В карточке видно, какие наряды проекта идут в то же время. Если рядом огневые работы в том же месте, наряд не отправить на подпись без обоснования и мер.',
      'Выдавший может продлить наряд: новый срок — не больше наибольшего из настроек, допуски бригады должны действовать и на новый срок. Продление видно в журнале наряда.',
      'В «Настройках нарядов» — какие виды работ требуют изоляций и какие дают огонь или искру, и перечень способов изоляции.',
    ],
  },
  {
    id: '2026-10-28-regulation-basis',
    at: '2026-10-28T06:45:00.000Z',
    title: 'Регламенты компании и основание сроков',
    modules: ['admin'],
    items: [
      'В Настройках появился блок «Регламенты и основания сроков»: можно добавить готовый регламент или загрузить свой файл PDF или Word — текст прочитается, пункты станут доступны для выбора.',
      'Для каждого срока в форме администратор выбирает регламент и пункт; в форме письма и замечания надзора под сроком появляется «Основание: регламент, п. N».',
    ],
  },
  {
    id: '2026-10-28-substitution-notices',
    at: '2026-10-28T01:30:00.000Z',
    title: 'Замещение: поручения и оповещения — заместителю',
    modules: [],
    items: [
      'Пока человек в отпуске или в командировке, его поручения видны заместителю в «Ждёт меня», в «Поручениях» и в утренней сводке с пометкой «за <ФИО>». Заместитель может отметить поручение выполненным — в истории будет его имя.',
      'Рабочие оповещения отсутствующего (сроки обращений в поддержку, письмо «Просрочки команды» руководителю проекта) приходят и заместителю. Личные — ответы по своим обращениям, премии, предложения — нет.',
      'Когда администратор назначает замещение, заместитель и замещаемый получают письмо с датами. Суммы заместитель видит, только если владелец выдал ему уровень денег на срок замещения.',
    ],
  },
  {
    id: '2026-10-28-role-guide-word',
    at: '2026-10-28T01:53:00.000Z',
    title: 'Помощь: инструкция по роли в Word',
    modules: [],
    items: [
      'В «Помощи» рядом с PDF появилась ссылка «Инструкция по моей роли, Word»: тот же текст, что на экране, можно доработать и раздать команде.',
      'В инструкцию попадают только ваши разделы; без права на деньги разделов с суммами в файле нет.',
    ],
  },
  {
    id: '2026-10-27-save-psd-offline',
    at: '2026-10-27T22:08:00.000Z',
    title: 'ПСД: «Сохранить для офлайн»',
    modules: ['psd', 'site'],
    items: [
      'У листа и комплекта ПСД появилась кнопка «Сохранить для офлайн»: файлы действующей ревизии скачиваются на телефон и открываются без связи. Видно, сколько места занято и когда сохранено.',
      'Если выпущена новая ревизия, портал предупредит, что на телефоне устаревшая, и обновит её одной кнопкой. Со связью лист всегда открывается с сервера. При выходе из портала сохранённое стирается.',
    ],
  },
  {
    id: '2026-10-27-take-on-watch',
    at: '2026-10-27T20:20:00.000Z',
    title: 'Площадка: «Взять на вахту»',
    modules: ['site'],
    items: [
      'На странице «Мой день» одной кнопкой можно сохранить на телефон план дня, открытые замечания и шаблоны чек-листов, чтобы они открывались без связи. Видно, когда сохранено, сколько места занято и сколько записей ещё не отправлено.',
      'Сохранённое обновляется само: по Wi-Fi сразу, по мобильной сети — если вы это разрешили. Закрытые замечания на телефон не берутся.',
    ],
  },
  {
    id: '2026-10-27-rotation-grid',
    at: '2026-10-28T04:30:00.000Z',
    title: 'Сетка вахт «люди × дни»',
    modules: ['resources'],
    items: [
      'В «Ресурсах» на вкладке «Вахты» появилась сетка на месяц: по строке на человека, по столбцу на день; в клетке видно, кто на вахте по плану и кто по факту. Внизу — сколько людей на вахте в каждый день.',
      'Вахты можно заполнить по графику 15/15, 28/28 или 30/30 сразу для нескольких людей: заезд, отдых и следующий заезд создаются подряд, а дни, где у человека уже есть вахта, пропускаются.',
      'Под сеткой — проверка месяца: пересечения вахт, заезд без отметки, поздний или ранний заезд и выезд, отдых короче положенного.',
    ],
  },
  {
    id: '2026-10-28-permit-air',
    at: '2026-10-28T04:30:00.000Z',
    title: 'Наряды-допуски: анализ воздуха и остановка работ',
    modules: ['qhse'],
    items: [
      'В наряде-допуске появился анализ воздуха рабочей зоны: компоненты и допустимые значения берутся из настроек компании. Газоопасные и огневые работы не начать без свежего анализа в норме.',
      'Если в ходе работ анализ показал превышение, портал сам останавливает работы: план дня перестаёт видеть наряд действующим, ответственный и выдавший получают дело и письмо. Возобновить можно только после нового анализа без превышений.',
      'Остановить работы может и любой из бригады. Все шаги наряда видны в журнале на его карточке.',
      'Качество и ОТ → «Наряды-допуски» → «Настройки нарядов»: какие виды работ оформляются, какие удостоверения нужны бригаде, сколько человек, нужен ли согласующий и анализ воздуха, допустимые значения и сроки.',
    ],
  },
  {
    id: '2026-10-27-mail-review',
    at: '2026-10-27T21:51:00.000Z',
    title: 'Режим проверки почты компании',
    modules: ['admin'],
    items: [
      'Пока портал настраивается, администратор может включить режим проверки: все письма портала по компании приходят выбранным проверяющим с пометкой, кому письмо предназначалось, а людям ничего не уходит. Приглашения в портал уходят адресату.',
      'Включить и выбрать проверяющих — Администрирование → Настройки → «Режим проверки почты». Там же видны последние письма на проверку.',
    ],
  },
  {
    id: '2026-10-27-site-report-submit',
    at: '2026-10-27T21:33:00.000Z',
    title: 'Площадка: отчёт смены с фото сдаётся без помех',
    modules: ['site', 'schedule'],
    items: [
      'Отчёт смены с фото теперь сохраняется на сервере и уходит на проверку: раньше после загрузки фото кнопка «Сохранить на сервере» не включалась.',
      'Часовой пояс места работ подставляется сам — из настроек компании; вводить его вручную больше не нужно.',
      'Пакет работ не выдаётся, если у работы не задана единица объёма: по такой работе прораб не может внести объём. Портал покажет, у каких работ указать единицу.',
    ],
  },
  {
    id: '2026-10-27-deadline-control',
    at: '2026-10-27T20:31:00.000Z',
    title: 'Контроль сроков по команде',
    modules: ['admin'],
    items: [
      'Руководитель проекта раз в день получает письмо: какие поручения просрочены у каждого сотрудника его команды, на сколько дней, со ссылкой.',
      'Отказаться от письма можно в своём профиле: Профиль → Уведомления → «Просрочки команды». Выключить для всей компании — Администрирование → Настройки.',
    ],
  },
  {
    id: '2026-10-27-suggestion-rewards',
    at: '2026-10-27T18:59:00.000Z',
    title: 'Премии за предложения и анализ предложений',
    modules: ['support'],
    items: [
      'В «Поддержке» появилась вкладка «Премии»: как начисляются баллы за предложения, голоса коллег и подтверждённые ошибки, ваши баллы и место за месяц и из каких записей они сложились. Лучшие предложения и победители прошлых месяцев видны всем.',
      'Победителей выбирает человек после конца месяца: портал подсказывает лучшие предложения и самых активных, суммы видит только тот, кто утверждает премии.',
      'Специалистам поддержки — вкладка «Анализ предложений»: что ждёт решения дольше двух недель, что делать первым по пользе, трудоёмкости и голосам, похожие предложения с объединением повторов, разделы, месяцы и выгрузка в Excel.',
    ],
  },
  {
    id: '2026-10-27-report-button',
    at: '2026-10-27T18:59:00.000Z',
    title: 'Кнопка «Сообщить» на каждой странице',
    modules: ['support'],
    items: [
      'Вверху каждой страницы появилась кнопка «Сообщить» (на телефоне — круглая кнопка внизу справа, на компьютере — ещё клавиша «?»): выберите «Ошибка», «Нужна помощь» или «Доработка» и опишите одним текстом.',
      'Страница, снимок экрана и сведения о браузере приложатся сами. Снимок можно обвести рамкой или стрелкой, подписать и закрасить лишнее; на страницах с суммами он по умолчанию выключен.',
      'Для доработки портал сразу покажет похожие пожелания по этой странице — можно поддержать их «+1 мне тоже» вместо нового. Ответ поддержки придёт в «Ждёт меня».',
    ],
  },
  {
    id: '2026-10-27-extra-work-sign',
    at: '2026-10-27T18:31:00.000Z',
    title: 'Площадка: подпись акта допработ в кабинете',
    modules: ['site'],
    items: [
      'Заказчик или технадзор подписывает акт на допработы в кабинете: портал записывает, кто подписал, когда, и контрольную сумму содержания. Если что-то не так, акт возвращается прорабу с замечанием; прораб исправляет, и акт снова ждёт подписи.',
      'На странице актов появилась отметка «Заказчик подключён»: пока её нет, заказчик и технадзор актов не видят и ничего не получают.',
    ],
  },
  {
    id: '2026-10-27-finplan-baseline-articles',
    at: '2026-10-27T18:04:25.000Z',
    title: 'Финансовый план: сравнение с бюджетом по статьям',
    modules: ['budget'],
    items: [
      'В блоке «План рядом с расчётом себестоимости» ниже итогов видно сравнение по статьям расходов: что заложено в бюджете и что стоит в финансовом плане.',
    ],
  },
  {
    id: '2026-10-27-site-video-geotag',
    at: '2026-10-27T16:57:29.000Z',
    title: 'Площадка: место съёмки на видео',
    modules: ['site'],
    items: [
      'При съёмке короткого видео с камеры в отчёте смены можно сохранить место — так же, как на фото, только с согласия.',
    ],
  },
  {
    id: '2026-10-27-pilot-eval-auto',
    at: '2026-10-27T16:40:00.000Z',
    title: 'Pilot: модель проверяется сама после смены',
    modules: ['ai'],
    items: [
      'После смены модели Pilot контрольная проверка запускается сама; пока модель её не прошла, Pilot не отвечает.',
      'У владельца портала — вкладка «Pilot»: допущена ли модель, итог по каждому вопросу и кнопка «Проверить модель».',
    ],
  },
  {
    id: '2026-10-27-estimate-comments-inbox',
    at: '2026-10-27T16:40:00.000Z',
    title: 'Сметы: замечания к позициям в «Ждёт меня»',
    modules: ['estimates'],
    items: [
      'Открытое замечание к позиции сметы теперь видно в «Ждёт меня» у сметчика: у создателя сметы и у того, за кем закреплён раздел позиции. Когда замечание отмечено «решено», строка пропадает.',
    ],
  },
  {
    id: '2026-10-27-money-portal-payments',
    at: '2026-10-27T16:47:00.000Z',
    title: 'Финансы: оплаты из банка и 1С',
    modules: ['finance', 'procurement'],
    items: [
      'В «Обмене с системами» появился коннектор «Money-портал»: адрес и ключ вводит администратор, платежи загружаются раз в час. Заявка на оплату сама отмечается «оплачено», когда совпали сумма, БИН и назначение.',
      'Неразнесённые платежи стоят в «Финансы → Оплаты из банка»: можно выбрать заявку, отнести платёж на проект или снять с учёта с причиной.',
    ],
  },
  {
    id: '2026-10-27-margin-accrued-tooltip',
    at: '2026-10-27T15:50:00.000Z',
    title: 'Маржа: подсказка про начисление с площадки',
    modules: ['budget', 'analytics'],
    items: [
      'В подсказке к «Начислено с площадки» видно, что в сумму входят люди, техника и материалы отчёта; подряд — отдельно, после актов.',
    ],
  },
  {
    id: '2026-10-27-warehouse-agsk-picker',
    at: '2026-10-27T14:49:00.000Z',
    title: 'Склад: класс АГСК-3 из справочника',
    modules: ['warehouse', 'norms'],
    items: [
      'В карточке позиции каталога ТМЦ класс АГСК-3 можно выбрать из классификатора нормативной базы по коду или названию; свой код по-прежнему принимается.',
    ],
  },
  {
    id: '2026-10-27-discussion-spawn-remark',
    at: '2026-10-27T14:13:00.000Z',
    title: 'Из сообщения — замечание надзора',
    modules: ['inbox', 'procurement', 'supervision'],
    items: [
      'У сообщения в обсуждении заявки или замечания в «Создать…» можно выдать замечание надзора: источник, вид, срок и ответственный.',
      'Связь видна с обеих сторон — у сообщения ссылка на замечание, в карточке замечания — откуда оно создано. Согласование и изменение из сообщения — позже.',
    ],
  },
  {
    id: '2026-10-27-estimate-item-comments',
    at: '2026-10-27T13:49:00.000Z',
    title: 'Сметы: комментарии к позициям',
    modules: ['estimates'],
    items: [
      'В раскрытой позиции сметы можно написать комментарий — замечание или пояснение. Автор или сметчик отмечает его «решено», возвращает в работу или убирает.',
    ],
  },
  {
    id: '2026-10-27-procurement-stage-sla',
    at: '2026-10-27T13:41:00.000Z',
    title: 'Закупки: сроки этапов настраивает администратор',
    modules: ['procurement'],
    items: [
      'В «Закупках» у администратора портала появилась кнопка «Сроки этапов»: сколько рабочих дней отводится на каждый этап заявки. Просрочка на доске и в «Ждёт меня» считается по этим срокам.',
    ],
  },
  {
    id: '2026-10-27-procurement-overview-filters',
    at: '2026-10-27T12:43:00.000Z',
    title: 'Закупки: фильтры в сводке руководителя',
    modules: ['procurement'],
    items: [
      'В сводке закупок можно отобрать заявки по этапу, ответственному, выбранному поставщику и периоду создания: счётчики, просрочки и суммы пересчитываются по выбранным заявкам.',
    ],
  },
  {
    id: '2026-10-27-site-delivery-offline',
    at: '2026-10-27T13:42:00.000Z',
    title: 'Площадка: приёмка поставки без связи',
    modules: ['site', 'warehouse'],
    items: [
      'Если связи нет, приёмка материала с «Мой день» сохраняется на телефоне вместе с фото и уходит сама, когда сеть появилась.',
    ],
  },
  {
    id: '2026-10-27-estimate-copy-version',
    at: '2026-10-27T13:16:00.000Z',
    title: 'Сметы: копия утверждённой версии для правок',
    modules: ['estimates'],
    items: [
      'В карточке утверждённой сметы появилась кнопка «Копия для правок»: создаётся новая версия с теми же разделами, позициями, ресурсами и связями с ПСД; работы графика переходят на новые позиции, прежняя версия остаётся как есть.',
    ],
  },
  {
    id: '2026-10-27-site-summary-inspections',
    at: '2026-10-27T12:34:00.000Z',
    title: 'Площадка: освидетельствование скрытых работ в сводке дня',
    modules: ['site', 'supervision'],
    items: [
      'В сводке дня площадки появился блок «Освидетельствование скрытых работ»: вызовы технадзора на сегодня и ближайшую неделю, с пометкой, если срок прошёл, а акт не подписан.',
    ],
  },
  {
    id: '2026-10-27-site-remark-offline',
    at: '2026-10-27T11:57:00.000Z',
    title: 'Площадка: замечание без связи с «Мой день»',
    modules: ['site', 'supervision'],
    items: [
      'Если связи нет, замечание с «Мой день» сохраняется на телефоне вместе с фото и уходит само, когда сеть появилась.',
    ],
  },
  {
    id: '2026-10-27-site-hidden-works-from-report',
    at: '2026-10-27T10:07:00.000Z',
    title: 'Площадка: скрытые работы из отчёта смены',
    modules: ['site', 'supervision'],
    items: [
      'В проверке отчёта смены у каждой работы появилась кнопка «Предъявить скрытые работы»: вызов технадзора на освидетельствование создаётся сразу с нужной работой и ссылкой на отчёт.',
      'В карточке вызова видна ссылка на отчёт смены, а в отчёте — вызовы по этой работе.',
    ],
  },
  {
    id: '2026-10-27-procurement-workdays',
    at: '2026-10-27T09:40:00.000Z',
    title: 'Сроки закупок по календарю Казахстана',
    modules: ['procurement'],
    items: [
      'Дни на этапе заявки и просрочка теперь считаются по производственному календарю РК: праздники и их переносы не считаются рабочими днями.',
    ],
  },
  {
    id: '2026-10-27-procurement-analysis-pdf',
    at: '2026-10-27T09:30:00.000Z',
    title: 'Коммерческий анализ закупки в PDF',
    modules: ['procurement'],
    items: [
      'В карточке заявки рядом с файлом Excel появилась кнопка «КА в PDF»: цены поставщиков по позициям, итоги, баллы, выбор и пояснение. Видна людям с уровнем денег «Акты и счета» и выше.',
    ],
  },
  {
    id: '2026-10-27-counterparty-check-pdf',
    at: '2026-10-27T08:45:00.000Z',
    title: 'Отчёт о проверке контрагента в PDF',
    modules: ['suppliers'],
    items: [
      'У каждой проверки контрагента появилась ссылка «Отчёт в PDF»: дата, источник, находки, решение Директора по «стопу» и QR-код на карточку контрагента. Отчёт можно приложить к закупке или договору.',
    ],
  },
  {
    id: '2026-10-27-estimate-change-requests',
    at: '2026-10-27T03:19:00.000Z',
    title: 'Сметы: изменения сметы по запросам на изменение',
    modules: ['estimates', 'changes'],
    items: [
      'В запросе на изменение можно указать, какую смету он затрагивает.',
      'В карточке сметы появился блок «Изменения по запросам»: какие запросы касаются сметы, что изменилось против прежней версии, что это дало бюджету и какие по ним допсоглашения.',
    ],
  },
  {
    id: '2026-10-26-budget-staff-fot',
    at: '2026-10-26T23:13:00.000Z',
    title: 'Бюджет: персонал по листу «ФОТ»',
    modules: ['budget'],
    items: [
      'В затратах площадки строка «ФОТ ИТР» считается как в листе «ФОТ» формы: человек, оклад, трудовое участие в процентах и налоги с ФОТ.',
      'Сумма в месяц считается сама и сразу входит в плановую себестоимость, маржу и распределение по разделам; монтажников добавляют отдельными строками по периодам.',
    ],
  },
  {
    id: '2026-10-27-site-day-video-count',
    at: '2026-10-27T10:36:00.000Z',
    title: 'Площадка: видео отдельно в сводке дня',
    modules: ['site'],
    items: ['В сводке дня и на обзоре проекта видно, сколько к отчётам приложили фото и сколько видео.'],
  },
  {
    id: '2026-10-27-site-video-compress',
    at: '2026-10-27T09:35:00.000Z',
    title: 'Площадка: сжатие видео перед отправкой',
    modules: ['site'],
    items: [
      'Крупное видео в отчёте смены сжимается на телефоне перед отправкой — по слабой связи уходит быстрее.',
    ],
  },
  {
    id: '2026-10-27-pilot-money-mask',
    at: '2026-10-27T09:38:00.000Z',
    title: 'Pilot: суммы по уровню денег спрашивающего',
    modules: [],
    items: [
      'В вопросах к Pilot и в его ответах суммы показываются только по уровню доступа к деньгам того, кто спрашивает: без права — без цифр, с ограниченным уровнем — в маске или словами.',
    ],
  },
  {
    id: '2026-10-27-site-report-video',
    at: '2026-10-27T08:21:00.000Z',
    title: 'Площадка: короткое видео в отчёте смены',
    modules: ['site'],
    items: [
      'К работе в отчёте смены можно приложить короткое видео (до минуты): с камеры или из галереи — хранится на телефоне и уходит при появлении связи, как фото.',
    ],
  },
  {
    id: '2026-10-27-site-photo-geotag',
    at: '2026-10-27T07:09:00.000Z',
    title: 'Площадка: место съёмки только с согласия',
    modules: ['site'],
    items: [
      'При съёмке фото для отчёта смены можно сохранить место — только если согласились; фоном телефон не отслеживается.',
    ],
  },
  {
    id: '2026-10-27-exec-transmittals',
    at: '2026-10-27T06:56:00.000Z',
    title: 'Документы: передача пакета исполнительной документации',
    modules: ['documents'],
    items: [
      'На странице «Исполнительная документация» можно оформить передачу пакета: кому и когда передан, какие готовые документы и файлы ушли. Каждой передаче присваивается номер ПН-0001, ПН-0002 и так далее.',
      'Когда получатель принял пакет, отметьте дату и кто принял. Если за пять дней получение не подтверждено, напоминание появится в «Ждёт меня».',
    ],
  },
  {
    id: '2026-10-27-counterparty-check-rules',
    at: '2026-10-27T06:42:00.000Z',
    title: 'Контрагенты: правила проверки по компании',
    modules: ['suppliers', 'procurement'],
    items: [
      'Директор настраивает, какие находки проверки контрагента считаются «стоп», «внимание» или справочными. Правила действуют на новые проверки; внесённые раньше не пересчитываются.',
    ],
  },
  {
    id: '2026-10-27-site-remark-markup',
    at: '2026-10-27T06:35:00.000Z',
    title: 'Площадка: пометка на фото в замечании с «Мой день»',
    modules: ['site', 'supervision'],
    items: [
      'При выдаче замечания с экрана «Мой день» на фото «до» можно обвести важное красным — пометка уходит вместе со снимком.',
    ],
  },
  {
    id: '2026-10-27-site-photo-markup',
    at: '2026-10-27T06:13:00.000Z',
    title: 'Площадка: пометка на фото отчёта смены',
    modules: ['site'],
    items: [
      'На снимке в отчёте смены до отправки можно обвести важное красным — пометка сохраняется в самом фото.',
    ],
  },
  {
    id: '2026-10-27-rfq-invite-steps',
    at: '2026-10-27T05:44:00.000Z',
    title: 'Закупки: статусы поставщиков в запросе КП',
    modules: ['procurement'],
    items: [
      'В запросе КП по каждому приглашённому поставщику видно: приглашение открыто, документы скачаны, будет участвовать, отказался, КП подано. Шаги отмечает закупщик со слов поставщика.',
      'Отказ поставщика записывается только с причиной, причина видна в списке.',
    ],
  },
  {
    id: '2026-10-26-pm12-clean-seed',
    at: '2026-10-27T09:38:00.000Z',
    title: 'Установка: своя компания без чужих проектов',
    modules: [],
    items: [
      'При установке на сервере заказчика портал больше не подставляет название и реквизиты чужой компании и не загружает пилотный проект Карабатан.',
      'Название компании задаётся в настройках установки или на странице первичной настройки; данные пилота включаются только явно на стенде разработчика.',
    ],
  },
  {
    id: '2026-10-26-fn20-works-match',
    at: '2026-10-27T09:38:00.000Z',
    title: 'Оплата: сверка подряда с принятыми объёмами площадки',
    modules: ['finance', 'procurement', 'site'],
    items: [
      'Перед оплатой по договору подряда, субподряда или услуг счёт или акт сверяется с принятыми объёмами площадки: без объёмов или сверх принятого заявка останавливается.',
      'Поставки по-прежнему сверяются с приходом на склад. Сумму в объёмах добавят после актов КС-2.',
    ],
  },
  {
    id: '2026-10-26-discussion-spawn-uv02',
    at: '2026-10-27T09:38:00.000Z',
    title: 'Из сообщения — поручение или вопрос',
    modules: ['inbox', 'procurement', 'supervision'],
    items: [
      'У сообщения в обсуждении заявки или замечания появилась кнопка «Создать…»: можно выдать поручение или зарегистрировать вопрос к проекту.',
      'Связь видна с обеих сторон: у сообщения — ссылка на созданную запись, у поручения и вопроса — ссылка обратно на обсуждение. Замечание надзора, согласование и изменение из сообщения — позже.',
    ],
  },
  {
    id: '2026-10-26-discussions-uv01',
    at: '2026-10-27T09:38:00.000Z',
    title: 'Обсуждение у заявки и замечания',
    modules: ['inbox', 'procurement', 'supervision'],
    items: [
      'В карточке заявки на закупку и замечания появился блок «Обсуждение»: можно писать сообщения коллегам по этой записи.',
      'Во вкладке «Сообщения» у колокольчика в шапке — ваши недавние обсуждения со ссылкой на карточку. Личные чаты, файлы и @упоминания — позже.',
    ],
  },
  {
    id: '2026-10-26-supplier-offer-file-zk19',
    at: '2026-10-27T09:38:00.000Z',
    title: 'Ответ на запрос КП файлом Excel или PDF',
    modules: ['procurement', 'suppliers'],
    items: [
      'В кабинете поставщика можно ответить на запрос КП не только формой, но и файлом Excel или PDF (в том числе сканом): файл загружается как обычное вложение.',
      'Excel с колонками «код», «название», «цена», «срок» раскладывается по позициям запроса в черновик КП; PDF остаётся вложением «на проверке». Снабженец в карточке запроса видит файл и подтверждает или правит позиции.',
    ],
  },
  {
    id: '2026-10-26-supplier-rfq-cabinet',
    at: '2026-10-27T09:38:00.000Z',
    title: 'Кабинет поставщика: ответ на запрос КП',
    modules: ['procurement', 'suppliers'],
    items: [
      'Внешний поставщик в «Кабинете поставщика» видит свои открытые приглашения на запрос КП и отвечает по позициям: цена, срок поставки, условия и комментарий — или отмечает отказ.',
      'Ответ становится обычным КП в заявках запроса: снабженец сравнивает и выбирает поставщика как раньше. Стоп-лист и чужие запросы из кабинета недоступны.',
    ],
  },
  {
    id: '2026-10-26-site-extra-works',
    at: '2026-10-27T09:38:00.000Z',
    title: 'Площадка: акт на дополнительные работы',
    modules: ['site', 'changes'],
    items: [
      'Прораб заводит акт на допработы за день: люди, техника, материалы, работа графика и договор.',
      'Когда акт подписывает заказчик или технадзор, портал сам создаёт запрос на изменение за счёт заказчика с номером акта как основанием; повторная подпись второй запрос не создаёт.',
      'Из акта открывается запрос на изменение, из запроса — обратно на акт.',
    ],
  },
  {
    id: '2026-10-26-finance-advances-fn06',
    at: '2026-10-27T09:38:00.000Z',
    title: 'Финансы: авансы и гарантийные удержания',
    modules: ['finance', 'contracts'],
    items: [
      'В «Финансы → Авансы и удержания» и в карточке договора видно выданные и полученные авансы: сколько зачтено по актам и какой остаток.',
      'Гарантийные удержания — с датой планового возврата и статусом; просроченные к возврату отмечены отдельно.',
    ],
  },
  {
    id: '2026-10-26-admin-delegations-ds07',
    at: '2026-10-27T09:38:00.000Z',
    title: 'Замещение на срок до 120 дней',
    modules: ['admin'],
    items: [
      'В «Администрирование → Замещения» можно назначить заместителя: он получает права замещаемого на выбранный срок.',
      'Деньги замещаемого без отдельной выдачи владельцем компании не открываются; действия заместителя в истории помечаются «за <ФИО>».',
    ],
  },
  {
    id: '2026-10-27-margin-site-materials',
    at: '2026-10-27T05:12:00.000Z',
    title: 'Маржа: материалы отчёта смены в начислении',
    modules: ['budget', 'site', 'warehouse'],
    items: [
      'В «Марже проекта» начисление с площадки включает материалы из списаний принятого отчёта смены; эти же списания не дублируются в строке «со склада».',
    ],
  },
  {
    id: '2026-10-27-site-remark-pb',
    at: '2026-10-27T04:07:00.000Z',
    title: 'Площадка: отдельный тип «Пожарная безопасность»',
    modules: ['site', 'supervision', 'qhse'],
    items: [
      'В замечании с «Мой день» и в разделе «Качество и ОТ» охрана труда и пожарная безопасность — разные типы; в реестре надзора у ПБ свой источник.',
    ],
  },
  {
    id: '2026-10-27-site-remark-sheet',
    at: '2026-10-27T03:03:00.000Z',
    title: 'Площадка: лист ПСД в замечании с «Мой день»',
    modules: ['site', 'supervision'],
    items: [
      'При выдаче замечания с экрана «Мой день» можно указать лист ПСД своего проекта — он попадёт в карточку замечания.',
    ],
  },
  {
    id: '2026-10-27-warehouse-autowriteoff',
    at: '2026-10-27T02:02:00.000Z',
    title: 'Склад: списание по норме из отчёта смены',
    modules: ['warehouse', 'site'],
    items: [
      'Если в принятом отчёте смены нет ручных материалов, склад списывает расход сам: принятый объём × норма из графика, со склада проекта.',
    ],
  },
  {
    id: '2026-10-27-role-compare',
    at: '2026-10-27T01:56:00.000Z',
    title: 'Администрирование: сравнение прав двух ролей',
    modules: ['admin'],
    items: [
      'На странице «Роли» можно выбрать две роли и увидеть, какие права есть только у одной, а какие общие.',
    ],
  },
  {
    id: '2026-10-27-site-photo-links',
    at: '2026-10-27T01:00:30.000Z',
    title: 'Площадка: фото к листу ПСД и замечанию',
    modules: ['site'],
    items: [
      'У фото в отчёте смены можно указать лист ПСД и замечание своего проекта — список подставляется с сервера, чужие записи отклоняются.',
    ],
  },
  {
    id: '2026-10-26-analytics-over-norm',
    at: '2026-10-27T00:12:00.000Z',
    title: 'Аналитика: перерасход материалов против нормы',
    modules: ['analytics', 'warehouse', 'budget'],
    items: [
      'В разборе проекта на экране руководителя видны списание со склада, начисление с площадки и перерасход против нормы выше порога компании.',
    ],
  },
  {
    id: '2026-10-26-site-day-plan-weather',
    at: '2026-10-26T23:07:00.000Z',
    title: 'Площадка: погода в плане дня',
    modules: ['site'],
    items: [
      'В плане дня показывается погода по адресу проекта и предупреждения: бетонирование в мороз (≤5 °C), работы на высоте и свайные при сильном ветре (≥10 м/с).',
    ],
  },
  {
    id: '2026-10-26-margin-over-norm',
    at: '2026-10-26T22:43:00.000Z',
    title: 'Маржа: перерасход материалов против нормы',
    modules: ['budget', 'warehouse'],
    items: [
      'В «Марже проекта» видна сумма перерасхода материалов выше порога компании: отклонение от нормы × средняя цена прихода на складах проекта.',
    ],
  },
  {
    id: '2026-10-26-warehouse-consumption-threshold',
    at: '2026-10-26T22:24:30.000Z',
    title: 'Склад: порог перерасхода в настройках компании',
    modules: ['warehouse'],
    items: [
      'В отчёте «Расход по факту против нормы» можно задать порог отклонения для компании (по умолчанию 1,5 %). Выше порога — отметка в отчёте и задача руководителю проекта.',
    ],
  },
  {
    id: '2026-10-26-site-autoweather',
    at: '2026-10-26T21:24:00.000Z',
    title: 'Площадка: автопогода в отчёте смены',
    modules: ['site'],
    items: [
      'В отчёте смены кнопка «Подставить» заполняет температуру, условия и ветер по Open-Meteo — по адресу проекта (для компаний KZ без адреса — Алматы). Значения можно поправить вручную.',
    ],
  },
  {
    id: '2026-10-26-site-day-on-project',
    at: '2026-10-26T20:43:00.000Z',
    title: 'Площадка: сводка дня в карточке проекта',
    modules: ['site'],
    items: [
      'На обзоре проекта блок «Площадка сегодня» показывает сводку за день: отчёты, люди, техника, фото, замечания и отставания — со ссылкой на полный экран сводки.',
    ],
  },
  {
    id: '2026-10-26-cash-gaps',
    at: '2026-10-26T20:45:00.000Z',
    title: 'ДДС: кассовые разрывы и чем они покрыты',
    modules: ['finance'],
    items: [
      'На вкладке «ДДС» видны периоды, когда денег не хватает: с какой по какую неделю или месяц и на какую сумму.',
      'Финансовый менеджер указывает, чем разрыв закрыт: кредит, гарантия, перенос платежей или средства компании. Портал считает покрытую и непокрытую часть и стоимость финансирования.',
      'Можно ввести остаток денег на начало периода — тогда разрывы считаются от него.',
    ],
  },
  {
    id: '2026-10-26-site-delivery-accept',
    at: '2026-10-26T19:53:00.000Z',
    title: 'Площадка: приёмка материала на площадке',
    modules: ['site', 'supervision'],
    items: [
      'В «Мой день» у поставки по договору можно принять материал: количество, накладная, фото и отметка о паспорте качества.',
      'Если паспорта нет — автоматически создаётся замечание поставщику. Поступление на склад по договору оформляется отдельно.',
    ],
  },
  {
    id: '2026-10-26-site-crew-export',
    at: '2026-10-26T19:17:00.000Z',
    title: 'Площадка: сводка численности по подрядчикам',
    modules: ['site'],
    items: [
      'На «Сводке дня» можно выбрать период и выгрузить численность и технику по подрядчикам в Excel или PDF — из отправленных и принятых отчётов смены.',
      'Повторное открытие уже принятого отчёта руководителем проекта — следующим шагом.',
    ],
  },
  {
    id: '2026-10-26-remark-after-photo',
    at: '2026-10-26T18:32:00.000Z',
    title: 'Надзор: закрытие замечания с фото «после»',
    modules: ['supervision', 'site'],
    items: [
      'Устранить и закрыть замечание или предписание можно только с фото «после»; закрывает выдавший с коренной причиной.',
      'Указания по-прежнему закрываются без фото «после».',
    ],
  },
  {
    id: '2026-10-26-site-day-plan-permits',
    at: '2026-10-26T18:05:00.000Z',
    title: 'Площадка: наряд-допуск в плане дня',
    modules: ['site', 'qhse'],
    items: [
      'В плане дня и при добавлении работы в отчёт смены видно, нужен ли наряд-допуск и действует ли он.',
      'Без действующего наряда работу нельзя открыть; люди на таких работах проверяются по удостоверениям вида наряда.',
    ],
  },
  {
    id: '2026-10-26-support-rating-report',
    at: '2026-10-26T18:02:00.000Z',
    title: 'Поддержка: оценка ответа, передача ошибки разработке, отчёт',
    modules: ['support'],
    items: [
      'После ответа поддержки можно оценить его: вопрос решён или нет и оценка от 1 до 5. Если вопрос не решён, обращение снова идёт в работу.',
      'Ошибку, которую нельзя исправить настройкой, специалист передаёт разработке с шагами воспроизведения. Автор видит, что ошибка у разработки, и получает сообщение, когда исправление выйдет.',
      'Выпущенные исправления появляются здесь же, в блоке «Исправлено по обращениям в поддержку».',
      'Специалистам поддержки — вкладка «Отчёт»: время первого ответа, нарушения сроков, оценки, частые темы по разделам и ролям и список доработок инструкций и экранов.',
    ],
  },
  {
    id: '2026-10-26-warehouse-issue-limit',
    at: '2026-10-26T17:43:00.000Z',
    title: 'Склад: выдача на работу с лимитом',
    modules: ['warehouse'],
    items: [
      'В выдаче можно выбрать работу графика: портал покажет лимит материала (объём работы × норма) и сколько уже выдано.',
      'Если выдать больше лимита, нужна причина и согласие руководителя проекта — дело придёт ему в «Ждёт меня», кладовщик проведёт документ после согласия.',
    ],
  },
  {
    id: '2026-10-26-finplan-baseline',
    at: '2026-10-26T17:29:00.000Z',
    title: 'Финансовый план рядом с расчётом себестоимости',
    modules: ['finance', 'budget'],
    items: [
      'В финансовом плане проекта появился блок «План рядом с расчётом себестоимости»: плановая себестоимость и маржа бюджета против закупок, персонала и административных расходов плана и против финансового результата.',
      'Видно сотрудникам с правом на бюджет и уровнем денег «Все».',
    ],
  },
  {
    id: '2026-10-26-site-copy-yesterday',
    at: '2026-10-26T17:37:00.000Z',
    title: 'Площадка: копия прошлой смены в новый отчёт',
    modules: ['site'],
    items: [
      'При старте отчёта можно подставить людей и технику из прошлой смены того же пакета — объёмы и фото вводят заново.',
      'Повторное открытие уже принятого отчёта руководителем проекта — следующим шагом.',
    ],
  },
  {
    id: '2026-10-26-contract-offer-check',
    at: '2026-10-26T17:34:00.000Z',
    title: 'Договоры: сверка с выбранным КП',
    modules: ['contracts', 'procurement'],
    items: [
      'Договор, созданный из заявки, сверяется с КП, по которому выбран поставщик: поставщик, цены и количества позиций, доставка, сумма, порядок оплаты и НДС.',
      'Если черновик договора хуже КП, автору приходит дело в «Ждёт меня». Изменение по подписанному допсоглашению отмечается, а не считается ошибкой.',
    ],
  },
  {
    id: '2026-10-26-exec-inventory',
    at: '2026-10-26T17:17:00.000Z',
    title: 'Документы: опись пакета исполнительной документации',
    modules: ['documents'],
    items: [
      'На странице «Исполнительная документация» кнопка «Собрать опись»: готовые документы по порядку со сквозным номером и файлами, ниже — чего в пакете ещё нет.',
      'Видно, можно ли передавать пакет: все ли обязательные документы готовы. Опись можно напечатать.',
    ],
  },
  {
    id: '2026-10-26-payment-budget',
    at: '2026-10-26T16:47:00.000Z',
    title: 'Бюджет: график оплат по неделям из условий договоров',
    modules: ['budget', 'finance'],
    items: [
      'На вкладке «Бюджет и маржа» появилась таблица «График оплат по неделям»: поступления от заказчика и платежи подрядчикам по условиям договоров, итог недели и нарастающий итог.',
      'Рядом показан план оплат разделов бюджета; платежи без даты и вне показанных недель выведены отдельной строкой.',
      'Видно сотрудникам с правом на бюджет и уровнем денег «Все».',
    ],
  },
  {
    id: '2026-10-26-estimate-psd-links',
    at: '2026-10-26T16:47:00.000Z',
    title: 'Сметы: позиция привязывается к комплекту и листу ПСД',
    modules: ['estimates', 'psd'],
    items: [
      'В смете у каждой позиции появился блок «Связи позиции»: можно привязать позицию к комплекту ПСД или к его листу — по каким чертежам посчитан объём. Здесь же видно, какие работы графика привязаны к позиции.',
      'В карточке комплекта ПСД показан список позиций смет, которые на него опираются, со ссылками в смету. Привязать позицию можно только к ПСД своего проекта; цены в этих блоках не показываются.',
      'Проверка сметы теперь напоминает, сколько позиций работ ещё не привязано к ПСД.',
    ],
  },
  {
    id: '2026-10-26-site-day-frames',
    at: '2026-10-26T16:37:00.000Z',
    title: 'Площадка: кадры дня в отчёте смены',
    modules: ['site', 'video'],
    items: [
      'В отчёте смены за день показаны кадры прогресса и подтверждённые события с камер проекта — со ссылкой в видеонаблюдение.',
      'Список доступен и без отдельного права на видео: достаточно права площадки на проект.',
    ],
  },
  {
    id: '2026-10-26-site-report-telemetry',
    at: '2026-10-26T16:19:00.000Z',
    title: 'Площадка: телематика в отчёте смены',
    modules: ['site', 'resources'],
    items: [
      'В отчёте смены за день показаны показания телематики техники проекта: моточасы, простой, топливо и пробег можно подставить в строку одним нажатием.',
      'Если ручной ввод сильно расходится с телематикой, в строке видно предупреждение.',
    ],
  },
  {
    id: '2026-10-26-site-report-weather',
    at: '2026-10-26T16:00:00.000Z',
    title: 'Площадка: погода в отчёте смены',
    modules: ['site'],
    items: [
      'В отчёте смены можно указать температуру, условия, ветер и короткий комментарий — видно при проверке.',
      'Автоподстановка с метеосервиса — позже.',
    ],
  },
  {
    id: '2026-10-26-pilot-eval-handover',
    at: '2026-10-26T15:33:00.000Z',
    title: 'Pilot: проверка модели перед подключением; пакет передачи заказчику',
    modules: ['ai', 'admin'],
    items: [
      'Новую версию модели Pilot сначала проверяют на наборе контрольных вопросов: если ответы хуже прежних, Pilot не отвечает на ней до проверки лучшей версии.',
      'Для установки у заказчика собирается пакет: исходный код, описание API и схемы данных, руководство администратора.',
    ],
  },
  {
    id: '2026-10-26-site-accepted-volumes',
    at: '2026-10-26T14:54:00.000Z',
    title: 'Площадка: накопленные объёмы для актов',
    modules: ['site'],
    items: [
      'Принятые объёмы смены по работам графика доступны списком для проекта (и функцией по договору) — основа для актов и сверки оплаты подряда.',
      'Суммы в деньгах появятся вместе с актами КС-2; подключение сверки оплаты — со стороны финансов.',
    ],
  },
  {
    id: '2026-10-26-site-report-materials',
    at: '2026-10-26T14:32:00.000Z',
    title: 'Площадка: списание материалов из отчёта смены',
    modules: ['site', 'warehouse'],
    items: [
      'В строке отчёта смены можно указать расход материалов со склада проекта: при принятии они списываются со склада без повторного списания при повторе.',
      'Если расход выше нормы, руководителю проекта ставится поручение. Накопление объёмов для актов — следующим шагом.',
    ],
  },
  {
    id: '2026-10-26-estimate-schedule-links',
    at: '2026-10-26T14:05:00.000Z',
    title: 'Смета: работы графика у позиции',
    modules: ['estimates', 'schedule'],
    items: [
      'В карточке позиции сметы видно связанные работы графика и можно привязать или отвязать работу (та же связь, что в карточке работы).',
      'Связь с листами ПСД и ведомостями объёмов — следующим шагом.',
    ],
  },
  {
    id: '2026-10-26-work-journal',
    at: '2026-10-26T14:53:00.000Z',
    title: 'Документы: общий журнал работ',
    modules: ['documents', 'site'],
    items: [
      'Новая страница «Журнал работ» в разделе «Документы»: записи собираются сами из принятых отчётов смены — что сделано, какой объём принят, сколько людей, техники и фото.',
      'Выбираются проект, объект и период; журнал можно напечатать. Отчёты на проверке в журнал не входят, но на странице видно, сколько их ждёт.',
    ],
  },
  {
    id: '2026-10-26-exec-docs',
    at: '2026-10-26T14:53:00.000Z',
    title: 'Документы: перечень исполнительной документации и его готовность',
    modules: ['documents'],
    items: [
      'Новая страница «Исполнительная документация» в разделе «Документы»: перечень обязательных документов по объекту и работе графика — акты скрытых работ, схемы, журналы, протоколы, паспорта и сертификаты.',
      'Видно готовность в процентах и чего не хватает к какой работе. Документ считается готовым, когда приложен файл или есть подписанный акт освидетельствования; «не требуется» — только с причиной.',
      'Перечень собирается по шаблону для вида работ: шаблоны правит компания без программиста.',
    ],
  },
  {
    id: '2026-10-26-site-report-timesheet',
    at: '2026-10-26T13:49:00.000Z',
    title: 'Площадка: часы отчёта смены в табеле',
    modules: ['site', 'resources'],
    items: [
      'В строке отчёта можно выбрать работника проекта: при принятии отчёта его часы попадают в табель за день смены.',
      'Без выбора работника по-прежнему можно указать профессию и численность для сводки. Списание материалов со склада — следующим шагом.',
    ],
  },
  {
    id: '2026-10-26-front-readiness',
    at: '2026-10-26T12:55:00.000Z',
    title: 'Склад: готовность фронта работ по материалам',
    modules: ['warehouse'],
    items: [
      'В «Склад → Отчёты» появился отчёт «Готовность фронта работ»: по каждой незавершённой работе графика с нормой материала видно, сколько нужно на оставшийся объём, сколько доступно на складах проекта (за вычетом резерва), сколько уже в пути и чего не хватает.',
      'Заказанное, но ещё не отправленное, а также люди и допуски в отчёт пока не входят.',
    ],
  },
  {
    id: '2026-10-26-cashflow',
    at: '2026-10-26T07:20:00.000Z',
    title: 'ДДС проекта по неделям и месяцам',
    modules: ['finance'],
    items: [
      'В «Финансы» появилась вкладка «ДДС»: поступления и платежи по неделям или месяцам для проекта (со ссылки проекта) или всех доступных проектов, план и факт, нарастающий итог.',
      'Поступления берутся из графиков доходных договоров и отмеченных поступлений, платежи — из платёжного календаря. Персонал, налоги, банковские расходы и финансирование пока не учитываются. Вкладка видна с уровнем денег «Акты и счета» и выше.',
    ],
  },
  {
    id: '2026-10-26-contract-limits',
    at: '2026-10-26T06:30:00.000Z',
    title: 'Лимиты согласования договоров и допсоглашений',
    modules: ['contracts'],
    items: [
      'В «Финансы → Лимиты» появились действия «Согласование договора» и «Согласование допсоглашения»: можно задать предел суммы для роли или человека.',
      'Если сумма договора (или договора после допсоглашения) выше вашего лимита, согласовать пункт нельзя — портал назовёт следующих согласующих. Отказ и возврат лимитом не ограничены, владелец компании без лимита.',
    ],
  },
  {
    id: '2026-10-26-norm-consumption',
    at: '2026-10-26T14:53:00.000Z',
    title: 'Склад: расход по факту против нормы',
    modules: ['warehouse'],
    items: [
      'В «Склад → Отчёты» появился отчёт «Расход по факту против нормы»: сколько материала нужно на выполненный объём работ по графику и сколько на самом деле выдано и списано по проекту.',
      'Если расход выше нормы больше чем на 1,5 %, строка отмечена, а кнопка «Поставить задачи по перерасходу» ставит руководителю проекта поручение с причиной.',
    ],
  },
  {
    id: '2026-10-26-cp-checks',
    at: '2026-10-26T09:30:00.000Z',
    title: 'Проверка контрагентов: «стоп» закрывает выбор',
    modules: ['suppliers'],
    items: [
      'В карточке контрагента появился блок «Проверка контрагента»: отметьте находки (суды, налоговый долг, санкции и другие), портал сам скажет «без замечаний», «внимание» или «стоп»; вся история проверок хранится в карточке.',
      'Если есть проверка со «стопом» без решения Директора, контрагенту нельзя разослать запрос КП, принять и выбрать его КП, заключить расходный договор, пока Директор не запишет решение с причиной. Директору такое дело приходит в «Ждёт меня».',
      'Автоматические проверки по Kompra и КГД появятся после подключения этих источников, сейчас результат вносится вручную.',
    ],
  },
  {
    id: '2026-10-26-rfq',
    at: '2026-10-26T06:00:00.000Z',
    title: 'Запрос КП — отдельная запись со статусами',
    modules: ['procurement'],
    items: [
      'В закупках появилась вкладка «Запросы КП»: один запрос собирается из одной или нескольких заявок на этапе «Сбор КП», позиции берутся из заявок.',
      'Поставщиков можно подобрать по категориям из реестра контрагентов; поставщик из стоп-листа в запрос не попадает. Запрос идёт по статусам: черновик, разослан, приём ответов, сравнение готово, закрыт; отменить можно с причиной.',
      'Ответ поставщика вносится сотрудником с уровнем денег «Акты и счета» и выше и становится обычным КП в каждой заявке запроса, дальше работает сравнение и выбор поставщика. Вопросы и ответы ведутся в чате запроса.',
      'В «Ждёт меня» у закупщика появляются дела по запросам КП: подходит или прошёл срок ответа, а кто-то из поставщиков ещё не ответил; все поставщики ответили — пора сравнивать.',
    ],
  },
  {
    id: '2026-10-26-site-report-resources',
    at: '2026-10-26T12:57:00.000Z',
    title: 'Площадка: люди и техника в отчёте смены',
    modules: ['site'],
    items: [
      'В отчёте смены у каждой работы можно указать людей (профессия, численность, человеко-часы и простой) и технику из парка проекта с машино-часами и простоем.',
      'Список техники берётся с проекта. Материалы и списание со склада — следующим шагом.',
    ],
  },
  {
    id: '2026-10-26-margin-site-accrued',
    at: '2026-10-26T12:55:42.000Z',
    title: 'Маржа: начисление с площадки рядом с кассой',
    modules: ['budget', 'site'],
    items: [
      'В «Марже проекта» появилась строка «Начислено с площадки»: сумма утверждённых оценок по принятым отчётам смены (люди и техника своей бригады). Это не оплаты и не склад — себестоимость по начислению.',
      'Кассовая маржа по оплатам и «Списано со склада» как были. Материалы в начислении отчёта и подряд — следующим шагом.',
    ],
  },
  {
    id: '2026-10-26-hub-uv12',
    at: '2026-10-26T12:35:18.000Z',
    title: 'Шапка: сообщения и задачи в одном окне',
    modules: [],
    items: [
      'В шапке справа — колокольчик с числом дел из «Ждёт меня». Открывает окно с вкладками «Сообщения», «Уведомления» и «Задачи»; страница под ним не закрывается, на телефоне окно на весь экран, последняя вкладка запоминается.',
      'Во вкладке «Задачи» — ваши дела со ссылками «открыть» и поручения с отметкой «выполнено». Вкладки «Сообщения» и «Уведомления» пока готовятся (обсуждения у записей и лента оповещений).',
    ],
  },
  {
    id: '2026-10-26-site-day-summary',
    at: '2026-10-26T12:05:15.000Z',
    title: 'Площадка: сводка дня по проекту',
    modules: ['site'],
    items: [
      'Новый экран «Сводка дня» (Площадка → «сводка дня по проекту» или из «Мой день» / «Отчёт смены»): за выбранный день — сданные отчёты смены со ссылками на проверку, люди и техника из отчётов, число фото, открытые замечания (если есть право на надзор), отставания по графику и участки без отчёта.',
      'Краткий текст сводки собирается из этих цифр. Когда подключат Pilot, текст сможет готовить модель — цифры по-прежнему берутся только из отчётов и связанных разделов.',
    ],
  },
  {
    id: '2026-10-26-site-report-deadline',
    at: '2026-10-26T12:05:15.000Z',
    title: 'Площадка: срок сдачи отчёта смены',
    modules: ['site'],
    items: [
      'У компании задан час сдачи отчёта смены (по умолчанию 20:00 по часовому поясу уведомлений). После этого часа участки без сданного отчёта появляются в «Ждёт меня» у прораба и списком у руководителя проекта.',
      'На экране «Мой день» видно срок и отметку «сдан / не сдан» по каждому пакету. Список «кто не сдал» — Площадка → «кто не сдал отчёт смены» или из «Ждёт меня».',
      'Час сдачи меняет администратор в «Администрирование → Настройки».',
    ],
  },
  {
    id: '2026-10-26-letters',
    at: '2026-10-26T09:06:00.000Z',
    title: 'Документы: реестр входящих и исходящих писем',
    modules: ['documents'],
    items: [
      'Новая страница «Письма» (Документы → «Письма: входящие и исходящие»): все входящие и исходящие письма одним списком. Номер ВХ-0001 или ИСХ-0001 присваивается сам, без пропусков и повторов, отдельно по каждому проекту.',
      'У письма — корреспондент, тема, номер и дата на самом письме, скан, срок ответа и ответственный. Ответ на письмо отмечается ответным письмом из реестра; письмо без ответа закрывается с причиной.',
      'Просроченные ответы подсвечены, а ответственному письмо с нужным ответом приходит в «Ждёт меня». В списке есть отборы: проект, направление, состояние, «только мои», «просроченные», поиск.',
    ],
  },
  {
    id: '2026-10-26-site-my-day',
    at: '2026-10-26T06:10:00.000Z',
    title: 'Площадка: «Мой день» и замечание с фото',
    modules: ['site'],
    items: [
      'Новый экран «Мой день» (Площадка → «Мой день: неделя, поставки, наряды, замечания»): на день или неделю вперёд — выданные вам пакеты работ с объёмами, бригады и техника, поставки по договорам к приёмке, действующие наряды-допуски, открытые замечания и ваши отчёты смены. Разделы без права доступа (качество, склад, надзор) не показываются.',
      'Кнопка «Замечание с фото» там же: тип (качество, охрана труда и пожарная безопасность, экология), вид, что не так, фото с телефона, работа графика, место, ответственный, срок и остановка работ. Замечание попадает в общий реестр надзора; закрывает его тот, кто выдал, после фото «после».',
      'Экран отчёта смены (бывший «Мой день» на /site) теперь называется «Отчёт смены».',
    ],
  },
  {
    id: '2026-10-26-pilot-gateway',
    at: '2026-10-26T08:59:00.000Z',
    title: 'Pilot: защита данных до подключения модели',
    modules: ['ai'],
    items: [
      'Pilot пока не подключён: модель появится, когда будет готов сервер в Казахстане. Сейчас портал прямо пишет «Pilot пока не подключён» и ничего не выдумывает.',
      'Когда модель подключится, ИИН, номер удостоверения, дата рождения и оклад в вопрос к ней не попадут — портал вырезает их сам, в том числе из таблиц.',
      'Каждый ответ Pilot будет помечен «Подготовлено ИИ». Журнал обращений хранит только, кто и когда спрашивал, без текста вопросов и ответов.',
    ],
  },
  {
    id: '2026-10-26-resource-budget',
    at: '2026-10-26T07:28:00.000Z',
    title: 'Бюджет: стоимость ресурсов графика по неделям',
    modules: ['budget', 'resources'],
    items: [
      'На вкладке «Бюджет и маржа» появилась таблица «Стоимость ресурсов графика по неделям»: ФОТ, техника и материалы по назначениям работам графика рядом с планом оплат бюджета и разница по неделям.',
      'Ресурсы без ставки на дату показаны отдельно — их стоимость в таблицу не входит. Видно сотрудникам с уровнем денег «все деньги».',
    ],
  },
  {
    id: '2026-10-26-actual-warehouse',
    at: '2026-10-26T06:02:00.000Z',
    title: 'Маржа проекта: списано со склада на проект',
    modules: ['budget'],
    items: [
      'В «Маржа проекта» появилась карточка «Списано со склада на проект»: проведённые списания и расход у получателя по проекту, без сторнированных. Цена берётся из документа, а если её нет — средняя цена прихода по складу. Строки без цены не считаются, их число показано рядом.',
    ],
  },
  {
    id: '2026-10-26-budget-changes',
    at: '2026-10-26T05:57:00.000Z',
    title: 'Изменения утверждённого бюджета по документу',
    modules: ['budget'],
    items: [
      'В «Бюджет и маржа» появился блок «Изменения бюджета»: допработы, экономия и перерасход утверждённого бюджета записываются суммой по разделу и только со ссылкой на документ — запрос на изменение, допсоглашение или договор.',
      'Изменение предлагает тот, кто правит бюджет, а утверждает другой человек с правом «Утверждать бюджет»; он видит его в «Ждёт меня». Утверждённая сумма входит в бюджет раздела и в маржу проекта.',
    ],
  },
  {
    id: '2026-10-25-inbox-sources',
    at: '2026-10-25T09:00:00.000Z',
    title: '«Ждёт меня»: изменения, отчёты смены, техника, обмен с системами',
    modules: [],
    items: [
      'Запрос на изменение, где сейчас ваш шаг согласования, появляется в «Ждёт меня» — до этого его было видно только в разделе «Изменения». Шаг заказчика или проектировщика появляется у них, когда компания согласовала запрос внутри.',
      'Проверяющему площадки — отчёты смены на проверке и проверенные, ждущие принятия, одной строкой по проекту. Свои отчёты проверяет другой человек и у автора в списке их нет.',
      'Документы техники со сроком в ближайшие 30 дней и просроченные; администратору — записи, которые не ушли во внешние системы.',
    ],
  },
  {
    id: '2026-10-24-amendment-from-change',
    at: '2026-10-25T07:04:00.000Z',
    title: 'Допсоглашение из запроса на изменение',
    modules: ['contracts', 'changes'],
    items: [
      'В карточке договора — запросы на изменение, которые его затрагивают. По утверждённому запросу кнопка «Допсоглашение по запросу» открывает проект допсоглашения: причина, обоснование, новая сумма и срок подставляются из запроса.',
      'Когда допсоглашение подписано, это видно в ходе запроса. Допсоглашение с заказчиком снимает риск «работы до допсоглашения».',
      'Из карточки договора и заявки на закуп можно открыть новый запрос на изменение — договор или заявка сразу попадают в затронутые записи.',
    ],
  },
  {
    id: '2026-10-24-stock-and-deliveries',
    at: '2026-10-25T07:04:00.000Z',
    title: 'Закупки и договоры: «со склада» с учётом пути, график поставок после допсоглашения',
    modules: ['procurement', 'contracts', 'warehouse'],
    items: [
      'В заявке на закуп «со склада N» теперь считает и материал, который уже едет перемещением на склад проекта: цифра та же, что в подборе со склада, и «к закупке» не завышается, пока перемещение в пути.',
      'После подписания допсоглашения с новым графиком поставок или спецификацией отметки «поставлено» в графике сразу пересчитываются по тому, что уже принято на склад, а не ждут следующего поступления.',
    ],
  },
  {
    id: '2026-10-24-excess-withheld',
    at: '2026-10-25T07:04:00.000Z',
    title: 'Оплата подрядчику: удержание перерасхода давальческих материалов',
    modules: ['procurement', 'warehouse'],
    items: [
      'В заявке на оплату по договору подряда или субподряда видно, сколько давальческих материалов подрядчик израсходовал сверх нормы. «Удержать из суммы» уменьшает сумму к оплате на перерасход по отчётам, которые утвердил руководитель проекта, и дописывает основание в назначение платежа.',
      'Один перерасход удерживается один раз: удержанные отчёты больше не предлагаются, а если их успела удержать другая заявка, портал попросит обновить форму. Отчёты, которые ещё ждут решения руководителя проекта, показываются предупреждением.',
      'Если заявку на оплату отменить, удержание снимается, и перерасход снова будет предложен в следующей заявке.',
      'Удержанная сумма вместе с оплатой закрывает акт: она идёт в счёт суммы договора и закрывает плановый платёж. В карточке заявки она видна сотрудникам с уровнем денег «Акты и счета».',
    ],
  },
  {
    id: '2026-10-20-payment-control',
    at: '2026-10-21T07:34:00.000Z',
    title: 'Оплата поставки: сверка счёта с договором и приходом, лимиты согласования, выгрузка в 1С',
    modules: ['procurement', 'finance'],
    items: [
      'Сверка счёта перед оплатой: в заявке на оплату вносятся позиции счёта или ЭСФ поставщика, портал сверяет их со спецификацией договора по цене и количеству и с проведённым приходом на склад. Допуск по цене и количеству задаёт администратор, по умолчанию 0 %.',
      'Расхождение сверх допуска останавливает заявку. Решением финансового менеджера остановка не снимается: нужно допсоглашение или исправление прихода, затем «Сверить заново». Сверка повторяется и при отметке оплаты.',
      'Лимиты согласования по сумме и по превышению сметы для роли и для человека (Финансы → «Лимиты и сверка»): выбор поставщика и передачу заявки на оплату выше лимита портал не принимает и называет, кто решает дальше.',
      'Выгрузка заявок на оплату в 1С (Финансы → «Выгрузка в 1С»): файл CSV или Excel либо ответ API. Какие поля портала в каких колонках и как они названы — настраивается профилем, потому что поля обмена с бухгалтерией ещё не согласованы. Журнал выгрузок, повторная выгрузка не берёт уже выгруженное.',
    ],
  },
  {
    id: '2026-10-20-fleet',
    at: '2026-10-21T05:22:17.000Z',
    title: 'Техника: парк, путевые листы, топливо, стоимость машино-часа',
    modules: [],
    items: [
      'Раздел «Техника»: парк с документами и сроками, наряды и путевые листы с телефона, табель, заправки против нормы, стоимость машино-часа и выработка по работам.',
      'Путевой лист подписывают машинист и прораб; часы попадают в график, а стоимость — в списание на работу.',
      'Перерасход топлива сверх нормы приходит механику и руководителю проекта в «Ждёт меня».',
    ],
  },
  {
    id: '2026-10-20-video-scaffold',
    at: '2026-10-21T05:10:26.000Z',
    title: 'Видеонаблюдение: карточки камер, события аналитики и журнал просмотров',
    modules: ['video'],
    items: [
      'Раздел «Видеонаблюдение»: карточка камеры — проект, объект, место на плане, назначение, «в сети» или «нет сигнала»; число камер ограничивает тариф.',
      'События видеоаналитики — записи портала с кадром и решением человека: подтвердить, отклонить или превратить в замечание качества; событие по технике безопасности создаёт замечание в реестре надзора.',
      'Журнал просмотров: кто и когда открывал камеру или кадр; записи не удаляются и не правятся.',
      'Распознавание лиц — только при письменном согласии работника и утверждённой политике; согласие можно отозвать.',
      'Видеосервера и моделей распознавания пока нет: события принимаются по ключу компании, у демо-компании внешние каналы выключены.',
    ],
  },
  {
    id: '2026-10-20-platform-sales',
    at: '2026-10-21T02:54:00.000Z',
    title: 'Лицензия: счета и оплата, ключ для установки, оформление, регистрация',
    modules: [],
    items: [
      'Администрирование → «Лицензия»: счета на оплату, запрос счёта, печатная форма и реквизиты для счетов.',
      'Администрирование → «Оформление»: название, логотип, цвета, подпись писем, форматы даты и чисел.',
      'Администрирование → «Данные людей»: запросы на выгрузку, исправление и удаление данных со сроком ответа.',
      'На главной странице — самостоятельная регистрация компании с подтверждением почты и пробным периодом.',
    ],
  },
  {
    id: '2026-10-21-analytics-reports-kb',
    at: '2026-10-21T01:19:00.000Z',
    title: 'Отчёты, настройка списков, выгрузки и база знаний',
    modules: ['reports', 'kb', 'analytics'],
    items: [
      'Раздел «Отчёты и списки»: готовые отчёты — еженедельный для заказчика (Word и PDF), план-факт к совещанию, отчёт по подрядчику; сводка руководителю приходит в 08:00, подписка включается на странице отчётов.',
      'Любой список можно настроить: колонки, отбор, группировку, сортировку и вид (таблица, доска, календарь, график); виды сохраняются личные или общие, выбор запоминается. Любой список и отчёт выгружается в Excel (итоги формулами) и PDF.',
      'Конструктор отчётов: выберите источник, поля, отбор, группировки и итоги, сохраните и поделитесь ссылкой.',
      'На экране «Руководителю»: рейтинг проектов с пояснением, кривые нарастающим итогом и три способа прогноза.',
      'Раздел «База знаний»: регламенты, правила расчётов, шаблоны, типовые решения и уроки проектов; у статьи есть владелец, версии с проверкой, срок пересмотра и поиск. Нормы открываются с оглавлением и поиском по тексту, на изменения можно подписаться.',
    ],
  },
  {
    id: '2026-10-21-site-photo-offline',
    at: '2026-10-20T19:40:00.000Z',
    title: 'Площадка: фото в отчёте смены и работа без связи',
    modules: ['site'],
    items: [
      'В отчёте смены у каждой работы можно снять фото камерой телефона или выбрать из галереи, подписать и убрать. Снимок сжимается на телефоне; фото из галереи помечено: время и место съёмки не подтверждены.',
      'Без связи отчёт и фото сохраняются на телефоне. Кнопка «Отправить, когда будет связь»: как только сеть появится, фото загрузятся, отчёт сохранится и уйдёт на проверку сам, один раз, без дублей. Если продолжить правку после нажатия, отправка снимается.',
      'Площадка и план дня открываются без сети, если вы заходили в неё раньше. При выходе из портала и при входе другого человека запомненное на телефоне стирается.',
      'Пока нет: видео, геометка, чертежи и чек-листы без сети, приложения для iOS и Android.',
    ],
  },
  {
    id: '2026-10-20-infra-notifications',
    at: '2026-10-20T22:20:00.000Z',
    title: 'Состояние системы: проверка почты и Telegram, предупреждения о выкладке, копии и мониторинг',
    modules: ['admin'],
    items: [
      'Администрирование → «Состояние»: видно, работают ли почта и бот Telegram, дошли ли сообщения сотрудникам; кнопки «Проверить сейчас» и «Прислать пробное мне».',
      'О выкладке новой версии теперь предупреждает не только плашка в портале: владельцам приходит сообщение на почту и в Telegram. Если канал не сработал, отправка повторяется, а недоставленное видно в журнале.',
      'Владелец портала видит последнюю копию базы и файлов, проверку восстановления, реплику, очереди и журнал сбоев; о сбое и о возвращении в порядок дежурным приходит оповещение.',
      'Подготовлен рабочий контур в Казахстане: установка на сервер, копии с шифрованием, восстановление на любой момент, реплика во втором дата-центре и план переноса.',
    ],
  },
  {
    id: '2026-10-20-safety',
    at: '2026-10-20T23:28:00.000Z',
    title: 'Охрана труда: наряды-допуски, инструктажи, допуски работников и наблюдения за безопасностью',
    modules: ['qhse'],
    items: [
      'Наряды-допуски на огневые, высотные, земляные, газоопасные работы, работы у ЛЭП и подъём кранами: подписи по маршруту, ознакомление бригады, срок действия, закрытие. Человек без нужного удостоверения в бригаду не попадает.',
      'Допуски и удостоверения работников со сроками: видно, у кого срок истёк или истекает.',
      'Инструктажи с подписью в приложении или на бумаге и журналом по форме; внеплановый — только с причиной, повторный — раз в 92 дня.',
      'Наблюдения за безопасностью: любой сотрудник отправляет фото опасной ситуации с телефона, при желании анонимно; страница «Сообщить об опасности» — по Ctrl+K или во вкладке «Наблюдения».',
    ],
  },
  {
    id: '2026-10-20-warehouse-qc',
    at: '2026-10-21T00:49:09.000Z',
    title: 'Склад: входной контроль партий с пробами и протоколом, удержание перерасхода',
    modules: ['warehouse'],
    items: [
      'Входной контроль партий: ОТК принимает или бракует партию, указывает отобранные пробы и протокол испытаний (номер и дата). Партия без решения не выдаётся.',
      'Вкладка «Склад → Входной контроль»: партии, ждущие решения, принятые и бракованные; в «Ждёт меня» — дело тем, кто ведёт проверки качества проекта склада.',
      'Решения руководителя проекта по складу (сверх лимита, перерасход, потеря, недостача, ведомость расхождений) теперь по отдельному праву «Решать по складу»; обмен с 1С — по праву «Обмен склада с 1С».',
      'Перерасход давальческих материалов в отчёте подрядчика показан отдельно по утверждённым и ещё не решённым отчётам; удержанный при оплате больше не предлагается повторно.',
    ],
  },
  {
    id: '2026-10-20-help-support',
    at: '2026-10-20T19:22:00.000Z',
    title: 'Помощь на каждой странице, обращения в поддержку и предложения',
    modules: ['support'],
    items: [
      'Кнопка «Помощь» в шапке на каждой странице: инструкция к этой странице для вашей роли, частые вопросы и переход в поддержку. Инструкция показывает только то, что открыто вам; суммы без права на деньги в ней не упоминаются.',
      'Экскурсия по разделам вашей роли открывается при первом входе и всегда доступна в меню профиля. Инструкцию по роли можно скачать в PDF.',
      'Обращение в поддержку с любой страницы: тему страницы, роль и устройство портал подставляет сам, можно приложить снимок экрана. У обращения есть номер, статус и ответственный; на первый ответ даём 2 часа, если работа стоит, и 4 рабочих часа в остальных случаях. Ответ приходит в «Ждёт меня».',
      'Предложения по порталу: коллеги голосуют, автор видит каждую смену статуса, отказ всегда с причиной. Выпущенные предложения появляются здесь, в «Что нового».',
      'Помощник Pilot пока не подключён: вопросы идут человеку в поддержку.',
    ],
  },
  {
    id: '2026-10-20-schedule-file-check',
    at: '2026-10-20T19:30:00.000Z',
    title: 'График: сверка файла Primavera и MS Project без загрузки',
    modules: ['schedule'],
    items: [
      'В окне «Загрузить файл» появилась кнопка «Сверить без загрузки»: портал читает XER, P6 XML или MS Project XML, считает график своим ядром и показывает, совпали ли ранние и поздние даты, резерв, критический путь и окончание проекта с расчётом исходной программы. График при этом не меняется.',
      'При обычной загрузке тот же отчёт теперь включает сравнение критического пути.',
      'На телефоне названия работ и узлов в диаграмме Ганта — кнопки высотой не меньше 44 px.',
    ],
  },
  {
    id: '2026-10-20-psd-links',
    at: '2026-10-20T19:21:00.000Z',
    title: 'ПСД, надзор и изменения: связи с графиком, качеством и тарифом',
    modules: ['psd', 'supervision', 'changes'],
    items: [
      'Запрос на изменение может ссылаться на затронутую работу графика (выбор работы в форме — со стороны графика). Запрос виден со стороны работы, а после утверждения планировщику проекта ставится поручение «вернуть график в работу».',
      'В карточке замечания надзора, созданного при приёмке по чек-листу, есть ссылка «Создано по чек-листу ЧЛ-… п. N» на саму приёмку (её видят сотрудники с доступом к разделу «Качество и ОТ»).',
      'Загрузка листов ПСД учитывается в лимите объёма файлов тарифа: при исчерпании лимита загрузка отклоняется понятным сообщением, а недогруженное не остаётся в хранилище.',
    ],
  },
  {
    id: '2026-10-20-access-money',
    at: '2026-10-20T19:57:00.000Z',
    title: 'Права и деньги: внешние участники видят только своё',
    modules: ['admin'],
    items: [
      'Подрядчик и поставщик видят суммы не выше уровня «Акты и счета»: уровень «Все деньги» (бюджет, маржа, договорная стоимость проекта) им не открывается, даже если выдан по ошибке.',
      'Лимиты платежей компании не показываются внешним участникам.',
      'Добавлена автоматическая проверка всех страниц и выгрузок портала: внешний участник не видит чужие проекты и организации, человек без права на деньги не видит сумм, компании не видят данные друг друга.',
    ],
  },
  {
    id: '2026-10-20-estimates-kenml2-reconcile',
    at: '2026-10-20T19:30:00.000Z',
    title: 'Сметы: сверка файла KENML 2.01 со сметой и классы АГСК-3 для склада',
    modules: ['estimates'],
    items: [
      'В карточке сметы, в окне «KENML 2.01», появилась кнопка «Сверить с файлом 2.01»: загрузите файл от проектировщика или нашу выгрузку — портал покажет расхождения с сметой до тенге по итогам и по каждой позиции и замечания к файлу по правилам экспертизы. Файл смета не меняет.',
      'Выгрузка KENML 1.0 и загрузка обратно проверены на тринадцати сметах (около 430 позиций): итоги и суммы позиций сходятся.',
      'Справочник классов АГСК-3 открыт складу для каталога ТМЦ (поиск по коду и словам, без цен).',
    ],
  },
  {
    id: '2026-10-20-integrations-layer',
    at: '2026-10-20T22:19:00.000Z',
    title: 'Обмен с внешними системами: коннекторы, очередь и режим «только файл»',
    modules: ['admin'],
    items: [
      'Администрирование → «Обмен с системами»: список внешних систем компании (1С, телематика, ЭЦП, Google Диск). Каждую можно включить и выключить без программиста, ключ доступа хранится зашифрованным и после сохранения не показывается.',
      'Поля обмена с 1С вы задаёте сами: для каждого вида записей — какое поле портала в какое поле или столбец 1С попадает, в каком виде (дата ДД.ММ.ГГГГ, сумма с запятой, константа) и какие поля обязательны. Пока формат с бухгалтерией не согласован, работает режим «только файл».',
      'Режим «только файл»: записи, которые разделы передали на выгрузку, скачиваются одним файлом (первый столбец — ключ обмена); когда 1С присвоит номера, они вносятся в очередь по одному или списком, и запись считается принятой.',
      'Очередь и журнал: если внешняя система недоступна, записи в портале создаются и согласуются как обычно, обмен ждёт; повтор через 5, 15 и 60 минут, дальше раз в час, потом — кнопкой «Повторить сейчас». Повтор не создаёт дублей. В журнале видно каждую попытку и текст ошибки.',
      'У демо-компании внешние каналы выключены: данные наружу не уходят, показан только пример сопоставления.',
    ],
  },
  {
    id: '2026-10-20-quality-checklists',
    at: '2026-10-20T18:52:00.000Z',
    title: 'Качество и ОТ: приёмки по чек-листам и замечания качества',
    modules: ['qhse'],
    items: [
      'Раздел «Качество и ОТ»: замечания и предписания ОТК, ОТ и ПБ, экологии — тот же единый реестр, что у надзора, с фото «до» и «после», сроком, ответственным и проверкой выдавшим.',
      'Конструктор шаблонов чек-листов: армирование, опалубка, бетонирование, сварка, изоляция, обратная засыпка. Пункты с ответами «соответствует», «не соответствует», «не применимо», число с допуском или дата. Шаблон правится без программиста.',
      'Приёмка по шаблону заполняется с телефона. Ответ «не соответствует» или число вне допуска сразу создаёт замечание в реестре с ответственным и сроком; без фото к такому пункту приёмку не завершить.',
      'Исполнитель получает приёмку в «Ждёт меня», в карточке проекта появилась сводка по открытым и просроченным замечаниям качества.',
    ],
  },
  {
    id: '2026-10-20-manager-screen',
    at: '2026-10-20T18:52:00.000Z',
    title: 'Экран «Руководителю»: сроки, деньги и маржа проектов на одной странице',
    modules: ['analytics'],
    items: [
      'Новый раздел «Руководителю»: по каждому проекту светофор, просрочка вех, оплачено, индексы SPI и CPI и маржа от плана к прогнозу. Выбрав проект, видно разбор ниже.',
      'Мост маржи показывает, куда ушла разница между плановой и прогнозной маржой: договор заказчика, договоры поставщиков, изменения. Каждая строка ведёт к документу.',
      'Отклонения по разделам и освоенный объём считаются теми же формулами, что в бюджете и графике, поэтому цифры совпадают. Суммы видны только с уровнем доступа к деньгам, сроки — всем, у кого есть право на аналитику.',
    ],
  },
  {
    id: '2026-10-19-site-schedule-eac',
    at: '2026-10-19T17:03:14.606Z',
    title: 'Принятый отчёт связан с графиком и оценкой затрат',
    modules: ['site', 'schedule', 'budget'],
    items: [
      'Серверное принятие отчёта фиксирует объём и выбранные шаги графика вместе. Повторная отправка не удваивает принятый объём.',
      'Принятый факт передаётся в бюджет. Затраты учитываются после отдельного утверждения оценки; до этого статус показывает ожидание доставки или оценки.',
      'Прогноз EAC проверяет полноту принятых оснований. Мобильный экран, фото, складские списания и автоматический сбор остальных источников прогноза остаются отдельными задачами.',
    ],
  },
  {
    id: '2026-10-19-inspection-safety',
    at: '2026-10-19T09:08:21.107Z',
    title: 'Надёжное создание актов и завершение приёмки',
    modules: ['supervision'],
    items: [
      'Подрядчик создаёт акт от своей организации в доступном проекте. Нумерация учитывает существующие акты, даже если часть из них ему не видна.',
      'Принимающего можно назначить только среди действующих участников с нужным правом и доступом к проекту. Ограничения внешнего профиля учитываются вместе с ролью.',
      'Загрузка фотографии и приёмка акта согласованы: фотография не добавляется после завершения приёмки.',
    ],
  },
  {
    id: '2026-10-19-s3-act-steps',
    at: '2026-10-19T06:43:37.654Z',
    title: 'Приёмка акта: выбор шагов и сохранение основания',
    modules: ['supervision', 'schedule'],
    items: [
      'В приёмке акта выберите конкретные выполненные шаги. Акт закроет только их, а процент работы пересчитается по весам шагов.',
      'Открытый актовый шаг нельзя закрыть вручную. Повторная отметка и правка примечания сохраняют исходный акт, автора и дату. После снятия отметки нужен новый принятый акт.',
      'Если все актовые шаги уже закрыты, дополнительный документ принимается по чек-листу без изменения процента и прежних оснований. При конфликте список шагов обновляется, заполненный чек-лист и комментарий сохраняются.',
    ],
  },
  {
    id: '2026-10-19-external-profiles',
    at: '2026-10-19T06:43:37.654Z',
    title: 'Точный доступ внешних участников к проектам',
    modules: ['admin'],
    items: [
      'При приглашении и настройке внешнего участника указываются его профиль, организация и конкретные проекты. Широкая роль не расширяет этот допуск.',
      'Отзыв проекта или роли закрывает связанный доступ. Назначенный надзор видит фотографии доступного ему акта; внутренний журнал и чужие проекты остаются закрыты.',
    ],
  },
  {
    id: '2026-10-19-storage-integrity',
    at: '2026-10-18T23:14:38.577Z',
    title: 'Надёжнее загрузка файлов',
    modules: [],
    items: [
      'Если загрузка большого файла прервалась, портал удаляет её незавершённые части и сохраняет причину ошибки.',
      'При отправке файлов добавлена проверка целостности переданных данных, совместимая с текущим хранилищем.',
    ],
  },
  {
    id: '2026-10-19-calendar',
    at: '2026-10-18T21:04:00Z',
    title: 'Личный календарь и подписка на него в телефоне',
    modules: ['calendar', 'procurement'],
    items: [
      'Новый раздел «Календарь»: месяц и повестка, отбор по проекту. В нём — ваши дела со сроком из «Ждёт меня», сроки поручений, которые вы выдали, вехи проектов, плановые платежи и поставки по договорам. Нажмите на событие, чтобы открыть его запись. Просроченное показано вверху повестки.',
      '«Подписка для телефона»: закрытая ссылка для Google Calendar, iPhone, Android и Outlook — события сами появляются в календаре телефона. Сумм и подробностей дел в нём нет. Ссылку можно выпустить заново или отозвать.',
      'Заявка на оплату по договору работ или субподряда показывает перерасход давальческих материалов подрядчика сверх нормы по этому проекту и даёт удержать его из суммы.',
    ],
  },
  {
    id: '2026-10-18-budget-margin-five',
    at: '2026-10-18T20:44:00Z',
    title: 'Бюджет: контрактная, прогнозная и фактическая маржа',
    modules: ['budget'],
    items: [
      'Проект → «Бюджет и маржа» → «Маржа проекта»: к сметной и плановой добавились контрактная маржа (подписанный договор заказчика без НДС минус подписанные договоры по разделам бюджета без НДС, остальные разделы — по плану), прогнозная (с запросами на изменение, которые на согласовании или утверждены, но ещё не внесены в сметы и бюджет) и фактическая по оплатам (поступления от заказчика минус оплаты, без НДС).',
      'Под карточками — отклонения прогноза по причинам изменений; подсказки на карточках объясняют, как считается каждая маржа.',
    ],
  },
  {
    id: '2026-10-18-schedule-contractors',
    at: '2026-10-18T20:33:00Z',
    title: 'График: кабинет подрядчика и его работы',
    modules: ['schedule'],
    items: [
      'Подрядчик в «Моём графике» видит только работы своей организации: план, базовый план и отклонение от него, факт. Кнопка «Отметить выполнение» отправляет генподрядчику начало, окончание, процент, остаток и объём.',
      'Генподрядчик на вкладке графика «Подрядчики» принимает отчёт в график (правка попадает в журнал и откатывается) или отклоняет с причиной, которую подрядчик увидит. Там же по каждому подрядчику — выполнение, окончание против базового плана и вклад его работ в перенос окончания проекта.',
      'В «Ждёт меня»: подрядчику — отметить выполнение начатых работ, генподрядчику — проверить отчёты.',
    ],
  },
  {
    id: '2026-10-18-psd-split-notice',
    at: '2026-10-18T20:12:00Z',
    title: 'ПСД: многостраничный PDF — по листам; извещение об изменении',
    modules: ['psd', 'changes'],
    items: [
      'Ревизия в разработке → «Файлы ревизии» → у PDF «Разложить по листам»: портал читает номер листа, шифр и номер изменения в основной надписи каждой страницы и предлагает лист ведомости; расхождения видны до сохранения.',
      'Запрос на изменение ПСД → «Извещение об изменении (PDF)»: основание, затронутые комплекты и листы, содержание изменения, инициатор, за чей счёт и согласование.',
    ],
  },
  {
    id: '2026-10-18-links-2',
    at: '2026-10-18T19:54:00Z',
    title: 'Связи разделов: договор и склад, обходной лист, внешние участники видят только своё',
    modules: ['contracts', 'procurement', 'admin', 'inbox'],
    items: [
      'Карточка договора: блок «Поставки на склад» — спецификация против полученного, недопоставка и поступления; строки графика поставок закрываются по мере приёмки на склад. У договора с заказчиком — блок «Материалы заказчика» и предупреждение об остатке давальческих перед закрытием.',
      'Заявка на закуп: у каждой строки — «подобрать со склада», а взятое со склада резервом видно прямо в строке вместе с остатком к закупке.',
      'Отключение сотрудника: если за ним числятся ТМЦ, инструмент или СИЗ, портал покажет перечень и попросит сначала принять всё на склад; отключить с долгом можно отдельной кнопкой.',
      'Внешние участники (подрядчик, поставщик): администратор указывает контрагента в карточке участника — после этого участник видит только договоры и оплаты своего контрагента.',
      '«Ждёт меня» и утренняя сводка собирают дела нормативной базы (документы на проверку сметному отделу и ГИП).',
    ],
  },
  {
    id: '2026-10-18-budget-plan-prices',
    at: '2026-10-18T19:45:00Z',
    title: 'Бюджет: справочник плановых цен проекта',
    modules: ['budget', 'estimates'],
    items: [
      'Проект → «Бюджет и маржа» → «Плановые цены проекта»: цена единицы материала без НДС и откуда она взята. Кнопки «Из КП и поставок» (последняя выбранная, иначе минимальная цена похожих КП и поступлений компании) и «Из смет» (цена ресурса в сметах проекта) заполняют справочник по материалам смет; цену можно задать и поправить вручную — такие строки заполнение не трогает. Рядом с каждой ценой — сколько материала в сметах и на сколько процентов цена отличается от сметной; список материалов смет, у которых плановой цены ещё нет.',
      'Вариант «свои силы» с источником «по плановым ценам»: материалы считаются сначала по справочнику проекта, потом по КП и поставкам компании, остальные — по смете; в списке материалов видно, откуда каждая цена («план проекта», «КП», «поставка»).',
      'Видят и правят те, кто видит сметы или бюджет проекта с уровнем денег «Акты и счета»; править — с правом на сметы или бюджет.',
    ],
  },
  {
    id: '2026-10-18-resources-telemetry',
    at: '2026-10-18T19:14:00Z',
    title: 'Техника: телематика из систем мониторинга',
    modules: ['resources'],
    items: [
      'Ресурсы → «Техника» → «Телематика»: загрузите файл системы мониторинга (Wialon и другие) — снимок парка по ISO 15143-3 в JSON или таблицу CSV по дням. Машина узнаётся по заводскому номеру (новое поле в карточке) или госномеру.',
      'По дням видны моточасы, простой, топливо, пробег; моточасы машины и срок ТО идут по счётчику, на карте — последнее место машины.',
      'При записи путевого листа показания дня можно подставить одной кнопкой; дни с показаниями без путевого листа собраны списком. Если путевой лист расходится с телематикой по часам, простою или топливу, это видно в списке и в отчёте по технике.',
    ],
  },
  {
    id: '2026-10-18-warehouse-customer-balance',
    at: '2026-10-18T19:02:00Z',
    title: 'Склад: остатки в отчёте заказчику, защита от двойного «Взять»',
    modules: ['warehouse'],
    items: [
      'Отчёт «Материалы заказчика» и печатная форма: остаток на начало и на конец периода (начало + движения периода), отдельно — остаток на сегодня.',
      'Подбор со склада: повторная отправка той же формы «Взять» (двойное нажатие, обрыв связи) не ставит второй резерв. Заявка и договор у поступления проверяются как существующие записи.',
    ],
  },
  {
    id: '2026-10-18-psd-compare-filters',
    at: '2026-10-18T18:32:00Z',
    title: 'Сравнение ревизий «рядом» и «шторкой»; отбор в реестре надзора; рассылка ответа на вопрос',
    modules: ['psd', 'supervision'],
    items: [
      'Сравнение ревизий листа: кроме наложения — два листа рядом с общей прокруткой и шторка, которую тянут влево-вправо. Выбранный вид запоминается.',
      'Реестр замечаний и вопросов: поиск по номеру и тексту, «Ещё отбор» — объект, марка комплекта, подрядчик, ответственный, срок до даты. Отбор сохраняется в адресе — ссылкой можно поделиться.',
      'Принимая ответ на вопрос к проекту, ПТО выбирает, кому его разослать: участники получают поручение «ознакомиться», а ответ сохраняется PDF-документом у вопроса.',
      'Надзор → «Сроки и просрочки»: какие источники замечаний внутренние (их не видят подрядчик, технадзор и проектировщик) — настройка компании.',
    ],
  },
  {
    id: '2026-10-18-estimates-price-history',
    at: '2026-10-18T18:30:00Z',
    title: 'Сметы и бюджет: история цен по поставщикам и материалы по лучшим ценам КП',
    modules: ['estimates', 'budget'],
    items: [
      'Смета → «Сравнение КП»: у каждой строки — колонка «Прошлые закупки, без НДС»: сколько раз компания уже покупала похожее, минимальная и последняя цена и у кого; строки этого же КП не считаются.',
      'История цен по названию: цены КП поставщиков по заявкам (с пометкой «выбрано») и проведённых поступлений на склад подбираются по словам названия и коду каталога, другой типоразмер («12 В» и «24 В») не смешивается; цены КП — без НДС по ставке на дату КП. Видят сотрудники с уровнем денег «Акты и счета» и доступом к сметам, закупкам или бюджету.',
      'Проект → «Бюджет и маржа» → себестоимость раздела → вариант «свои силы»: переключатель «Откуда цены материалов» — по смете, по лучшим ценам КП и поставок (найденные материалы — по последней выбранной или минимальной цене, остальные — по смете; показана доля найденных по сумме и список материалов с ценами) или своя сумма. Пока ни к одному материалу цен нет, такой вариант не выбирается (БМ-06).',
    ],
  },
  {
    id: '2026-10-18-schedule-forecast',
    at: '2026-10-18T18:19:00Z',
    title: 'График: прогноз окончания по выработке',
    modules: ['schedule'],
    items: [
      'В «Сценариях» — кнопка «Прогноз по выработке»: портал считает, сколько осталось начатым работам при их фактическом темпе (выполненный объём или процент с начала работы до даты отчёта), и показывает, когда при таком темпе закончится проект; прогноз можно применить к графику.',
    ],
  },
  {
    id: '2026-10-18-landing',
    at: '2026-10-18T18:08:00Z',
    title: 'Главная страница портала без входа — на русском, казахском и английском',
    modules: [],
    items: [
      'У портала появилась главная страница /welcome: что он делает и для кого, восемь разделов с короткими описаниями и снимками демо-компании, «Как устроено», тарифы, вопросы и ответы, контакты. Кнопки «Войти», «Попробовать демо» и «Запросить доступ» — на ней же.',
      'Три языка: русский, казахский и английский; выбор запоминается в браузере. Со страницы входа на главную ведёт ссылка «О портале».',
      'Не вошедший посетитель, открывший адрес портала, видит главную; ссылки на разделы по-прежнему ведут на вход и после входа открывают нужную страницу.',
    ],
  },
  {
    id: '2026-10-18-warehouse-preservation',
    at: '2026-10-18T17:56:00Z',
    title: 'Склад: консервация оборудования на хранении',
    modules: ['warehouse'],
    items: [
      'На позиции каталога «Инструмент и оборудование» — блок «Хранение и консервация»: условия хранения и периодические работы по требованиям изготовителя (проворот вала, смена консервирующего раствора, проверка сухого хранения) с интервалом и исполнителем — кладовщик склада или ответственный механик экземпляра.',
      'По каждому экземпляру на хранении портал считает срок следующей работы, ставит дело кладовщику или механику в «Ждёт меня», факт с фото записывается в карточку экземпляра; просроченная консервация видна в списке инструмента и попадает в «Требует внимания» проекта склада.',
    ],
  },
  {
    id: '2026-10-18-psd-search',
    at: '2026-10-18T17:31:00Z',
    title: 'Поиск по ПСД; отчёт по надзору для совещания и заказчика',
    modules: ['psd'],
    items: [
      'ПСД → «Комплекты»: строка поиска над реестром — по шифру и наименованию комплекта, номеру и названию листа.',
      'Ищется и текст самих листов PDF: надписи, основная надпись, спецификации, с учётом окончаний слов («трубы» найдёт «труба»). Результат — лист той страницы, где нашлось слово, с отрывком.',
      'Прораб и подрядчик находят только действующие ревизии. Новый файл попадает в поиск через несколько минут после загрузки; сканы без текстового слоя ищутся по шифру и наименованию.',
      'В карточке комплекта — предупреждение, если в основной надписи листа нет шифра комплекта.',
      'Надзор → «Отчёт и протокол»: открытые на дату замечания и вопросы к проекту, решения за период и поручения — для совещания и заказчика; печать и Excel.',
    ],
  },
  {
    id: '2026-10-18-resources-machines',
    at: '2026-10-18T13:28:00Z',
    title: 'Техника, вахтовый посёлок, освоенный объём',
    modules: ['resources', 'schedule'],
    items: [
      'Вкладка «Техника» в «Ресурсах»: машины парка — свои, в лизинге и аренде, моточасы, норма топлива и интервал ТО; предупреждение, когда ТО подходит или просрочено.',
      'Путевые листы по дням: маш.-ч на работах графика, простой с причиной, топливо по факту против нормы; отчёт по технике проекта за период со стоимостью смен по ставке справочника (по уровню денег «Акты»).',
      'Перемещение машины на другой проект — в карточке машины; машина в ремонте или с просроченным ТО перемещается только с подтверждением.',
      'Вкладка «Вахтовый посёлок»: места в общежитиях и вагон-домах, заселение вахты по факту заезда, выезд — по факту выезда вахты; занятость по дням против мест и плана вахт, питание и стоимость проживания.',
      'График → «Освоенный объём» (с уровнем денег «Акты»): план, освоено и факт затрат по базовому плану, SPI и CPI, прогноз затрат тремя способами и прогноз окончания, S-кривые и разрез по разделам, подрядчикам и видам работ.',
    ],
  },
  {
    id: '2026-10-18-org-structure-staff',
    at: '2026-10-18T13:06:00Z',
    title: 'Орг-структура и штат компании',
    modules: [],
    items: [
      'В «Администрировании» появилась вкладка «Орг-структура»: подразделения деревом и справочник сотрудников, почта необязательна.',
      'Список сотрудников можно загрузить целиком: сначала проверка, потом запись. Загрузка никому не выдаёт доступ.',
      'Пригласить сотрудника в портал можно из его карточки, с ролями; после принятия приглашения карточка связывается со входом.',
    ],
  },
  {
    id: '2026-10-18-estimates-object-ssr-forms',
    at: '2026-10-18T13:15:00Z',
    title: 'Сметы: объектная смета (Форма 3) и сводный сметный расчёт (Форма 1)',
    modules: ['estimates'],
    items: [
      'Карточка объектной сметы → вкладка «Форма 3»: строки — входящие локальные сметы с графами СМР, оборудование, прочие, всего, трудоёмкость и оплата труда (тыс. тенге); в «Связях» — глава сводного расчёта (1–7); подписи для печатной формы.',
      'Карточка сводного сметного расчёта → вкладка «Сводный расчёт»: главы 1–7 из объектных смет, глава 8 «Затраты на организацию и управление строительством» по норме НДЦС РК 8.04-09 (вид строительства и температурная зона или свой процент) и расчётные строки по ПОС, сметная прибыль 5 % от СМР глав 1–8, непредвиденные по стадии и назначению объекта, часть I (проектирование), часть III (инжиниринг процентом от части II), кварталы с индексами для переходящего объекта, НДС по периоду строительства (12 % до 2026 года, 16 % с 2026). Параметры — «Пересчитать и сохранить».',
      'Кнопки PDF и Excel у объектной сметы и сводного расчёта выгружают Форму 3 и Форму 1 по приложению Г НДЦС РК 8.01-08-2022: суммы в тыс. тенге с тремя знаками, в Excel — числами, пустые графы «--», подписи.',
    ],
  },
  {
    id: '2026-10-18-warehouse-customer',
    at: '2026-10-18T12:53:00Z',
    title: 'Склад: материалы заказчика',
    modules: ['warehouse'],
    items: [
      'Новый вид склада «Материалы заказчика»: заводится по заказчику и проекту, давальческие материалы заказчика числятся на нём отдельно от своих — на свой склад не перемещаются и подрядчику не передаются, только между складами этого заказчика.',
      'Отчёт «Материалы заказчика» в «Склад → Отчёты»: получено, израсходовано, списано и остаток за период по позициям, стоимость — по уровню денег; по складу заказчика — печатный «Отчёт об использовании материалов заказчика» с QR.',
    ],
  },
  {
    id: '2026-10-18-demo-and-links',
    at: '2026-10-18T12:41:00Z',
    title: 'Демо-компания «Попробовать демо» и связи разделов в карточке проекта и «Ждёт меня»',
    modules: [],
    items: [
      'На странице входа — «Попробовать демо»: выберите роль (руководитель проекта, снабженец, сметчик, прораб, подрядчик) и посмотрите портал на вымышленной компании «Демо Строй» без пароля. Сессия на два часа, роль меняется в плашке сверху, каждую ночь данные возвращаются к исходным. Для показа портала коллегам и новым компаниям.',
      'Карточка проекта: вкладки «Сметы» и «График» показывают сметы и диаграмму проекта, «ПСД» и «Ресурсы» ведут в разделы с отбором по проекту; на обзоре — склады проекта и кнопка «Склад объекта» для кладовщика.',
      '«Ждёт меня» и утренняя сводка теперь собирают дела графика (работы, которые пора начинать или которые просрочены) и склада (подтвердить выдачу, решить по расходу подрядчика, проверка инструмента).',
      'Стадия проекта «Закрыт» переводит остатки складов проекта черновиками перемещений на центральный склад — кладовщик проводит их сам.',
      'К документам склада можно прикладывать файлы; в истории изменений записи графика и склада подписаны по-русски; в меню больше нет пометки «эт. N» у разделов, которые уже выложены.',
    ],
  },
  {
    id: '2026-10-18-question-reminders',
    at: '2026-10-18T12:32:00Z',
    title: 'Вопросы к проекту: напоминания и эскалация срока ответа',
    modules: ['supervision'],
    items: [
      'Накануне срока ответа тот, кто передал вопрос проектировщику или заказчику, получает напоминание в «Ждёт меня».',
      'Срок прошёл — поручение ему и автору вопроса; через 3 рабочих дня просрочки (у вопроса «работы стоят» — сразу) — эскалация ГИП. Каждый шаг виден в ходе вопроса, у срока — отметка.',
      'В карточке вопроса — «Работы ждут ответа»: работы графика, которые не начать без ответа; на графике они отмечены.',
    ],
  },
  {
    id: '2026-10-18-schedule-packages',
    at: '2026-10-18T12:19:00Z',
    title: 'График: пакеты работ для бригад, журнал ограничений, подбор варианта',
    modules: ['schedule'],
    items: [
      'Вкладка «Пакеты работ»: задание бригаде на 1–2 недели — работы участка, объём и трудоёмкость, люди, техника и материалы, комплекты ПСД; печать.',
      'Ограничения пакета: портал сам видит неполученные комплекты ПСД, открытые вопросы к проекту, незаконченную предыдущую работу, неподписанный акт освидетельствования и незакрытые заявки на закуп; остальное ПТО отмечает с ответственным и сроком. Пакет выдаётся без открытых ограничений, исключение — руководитель проекта с причиной.',
      'В «Человеко-часах» — выработка против нормы: сколько часов табеля уходит на единицу выполненного объёма против нормы по плану, по работам и видам работ.',
      'В «Сценариях» — «Подбор варианта»: текущий график и сценарии по критерию — раньше окончание, меньше пик людей и техники или ровнее загрузка; варианты позже директивного срока отмечены.',
      'Журнал ограничений проекта: открытые ограничения со сроками, просроченные сверху; если обязательство недели не выполнено, причина берётся из ограничения пакета.',
    ],
  },
  {
    id: '2026-10-18-norms-library-drive-agsk',
    at: '2026-10-18T12:00:00Z',
    title: 'Нормативная библиотека: загрузка с Диска, перечни АГСК, список на проверку',
    modules: ['norms'],
    items: [
      'Нормативная база → «Загрузка документов»: папка Google Диска компании загружается только на чтение (сервисный аккаунт-читатель, папку задаёт владелец компании), а до настройки ключа — «Загрузить папку» или «Загрузить файлы» из браузера. Одна копия каждого файла по контрольной сумме, HTML-обёртки Диска заменяются исходным файлом, архивы zip и rar распаковываются; обозначение, выпуск, приказ и дата введения берутся с титула, а не из имени файла. Отчёт по каждому файлу: загружен, копия (где лежала первая), обёртка, архив, пропущен, на проверку, ошибка.',
      'Карточка документа: файлы со скачиванием и язык каждого; прежняя редакция, названная на титуле «взамен», получает статус «заменён», новая — «действует» с источником «титул: приказ № … от …».',
      '«Перечни АГСК и сверка статусов»: АГСК-1, АГСК-4 и АГСК-5 загружаются из PDF справочниками; каждый документ библиотеки сверяется с перечнем своего вида — совпала редакция: «действует» с источником «АГСК-N на дату», в перечне новее: «заменён», редакция позже перечня: по титулу или на проверку.',
      '«На проверку»: расхождения с перечнями, серии с одним номером и разными годами, титул против имени файла, нераспакованные архивы — сметному отделу или ГИП; «Решить» с текстом и, при необходимости, статусом документа (источник статуса — заметка сметного отдела).',
    ],
  },
  {
    id: '2026-10-18-warehouse-ppe',
    at: '2026-10-18T11:40:00Z',
    title: 'Склад: СИЗ по нормам',
    modules: ['warehouse'],
    items: [
      'Вкладка «Склад → СИЗ»: нормы компании на профессию (должность сотрудника) — позиция, количество, срок носки; карточка выдачи сотрудника: что по норме не выдано, в сроке, пора заменить или срок носки вышел; выдача документом выдачи со склада, получатель подтверждает в своём приложении, срок замены считается от даты выдачи.',
      'Замена: новая выдача закрывает прежнюю запись, старое списывается с рук документом «заявленный расход» на решение руководителя проекта. Кладовщику — список «кому выдать или заменить»; сотруднику — напоминание за 14 дней и при просрочке в «Ждёт вас по складу».',
    ],
  },
  {
    id: '2026-10-18-psd-review-routes',
    at: '2026-10-18T11:28:00Z',
    title: 'ПСД: проверка комплекта по маршруту',
    modules: ['psd'],
    items: [
      'ПСД → «Правило и маршруты»: маршрут проверки для марок и стадий проекта — шаги (например, нормоконтроль → сметчик → ГИП), проверяющие и правило «любые 2 из 3».',
      'Ревизия, отправленная на проверку, сама идёт по маршруту: проверяющие шага получают поручение в «Ждёт меня» и в карточке комплекта ставят каждому листу «принят», «принят с замечаниями» или «отклонён».',
      'Отклонил лист любой проверяющий — ревизия возвращается с замечаниями, а замечания остаются в ходе ревизии; все листы прошли все шаги — ревизия утверждена, и ГИП ставит штамп.',
    ],
  },
  {
    id: '2026-10-18-schedule-manhours',
    at: '2026-10-18T11:13:00Z',
    title: 'График: недельный план, бюджет человеко-часов, сводный график портфеля',
    modules: ['schedule'],
    items: [
      'Вкладка «Недельный план»: работы на 3–6 недель вперёд по участкам, план недели, бригадир подтверждает обязательство — дальше даты меняются только перепланированием с причиной; в конце недели — выполнено или нет и почему, процент выполненных обязательств по подрядчикам и участкам.',
      'Вкладка «Человеко-часы»: план трудоёмкости из назначений людей, освоено по проценту выполнения и шагам, факт из табеля; производительность и прогноз трудоёмкости до завершения — по разделам, видам работ, подрядчикам, захваткам и неделям.',
      'На странице «График» — сводный график всех проектов: окончание против базового плана и директивного срока, вехи; ниже — конфликты загрузки, когда людям одной профессии на нескольких проектах вместе нужно больше, чем их на вахтах.',
    ],
  },
  {
    id: '2026-10-18-warehouse-tool-repairs',
    at: '2026-10-18T09:15:00Z',
    title: 'Склад: ремонт, ресурс и ставка инструмента',
    modules: ['warehouse'],
    items: [
      'Карточка экземпляра: «В ремонт» — сервис (контрагент) или своими силами, срок и неисправность; пока в ремонте, выдача закрыта, просроченный ремонт — дело кладовщику. «Закрыть ремонт» — исправен (в работу) или не подлежит ремонту (списан), что сделано и затраты (по уровню денег «Склад»); история ремонтов на карточке и отчёт «Ремонты инструмента и затраты».',
      'Ресурс экземпляра — в днях на руках (по истории выдач) или в моточасах (вводятся при возврате): при 80 % — «почти выработан», при 100 % выдача закрыта, у руководителя проекта дело «продлить или списать»; продление — только РП с основанием.',
      'Ставка за день (вводит и видит уровень денег «Склад») и проект при выдаче: отчёт «Использование инструмента» считает календарные дни на руках за период по проекту × ставка — сумма к себестоимости проекта (проводку в бюджет сделает поток 1).',
    ],
  },
  {
    id: '2026-10-18-psd-share-link',
    at: '2026-10-18T09:05:00Z',
    title: 'Комплект ПСД по ссылке для получателя без учётной записи',
    modules: ['psd'],
    items: [
      'В отправленной исходящей накладной — блок «Ссылка для получателя» → «Новая ссылка»: укажите, кому, и срок (3–30 дней). Ссылка показывается один раз — скопируйте и отправьте заказчику, экспертизе или подрядчику.',
      'По ссылке получатель без входа в портал видит состав накладной с ревизиями на момент отправки и скачивает файлы; листы PDF получают водяной знак с номером накладной и получателем. Кнопка «Документацию получил» отмечает накладную полученной.',
      'В блоке видно, сколько раз ссылку открывали и сколько файлов скачано, кто подтвердил получение; в журнале просмотров ревизии — «По ссылке: получатель». Ненужную ссылку можно отозвать.',
    ],
  },
  {
    id: '2026-10-18-schedule-scenarios',
    at: '2026-10-18T08:37:00Z',
    title: 'График: сценарии «что если», шаги выполнения, запрет начала без акта освидетельствования',
    modules: ['schedule'],
    items: [
      'Вкладка «Сценарии»: проверьте, что будет со сроками, если поставка задержится, добавится бригада, изменится длительность, календарь или лаг связи. Портал считает сценарий, не меняя график, и сравнивает окончание, вехи и сдвинутые работы с текущим; подходящий сценарий применяется одной правкой, её можно отменить в журнале.',
      'Работу после скрытых работ нельзя отметить начатой, пока не подписан акт освидетельствования: предупреждение над диаграммой и в карточке работы со ссылкой на вызов.',
      'Шаги выполнения: в карточке работы выберите правило (например, трубопровод — доставка 10 %, монтаж 60 %, контроль стыков 20 %, гидроиспытание 10 %) — процент работы считается по закрытым шагам, а шаг «акт» закрывается только подписанным актом освидетельствования. Правила компании — в «Параметрах и календарях», правит администратор справочников.',
    ],
  },
  {
    id: '2026-10-18-licensing',
    at: '2026-10-18T08:25:00Z',
    title: 'Лицензии и тарифы: страница «Лицензия», кабинет владельца портала, заявка на доступ',
    modules: ['admin'],
    items: [
      'Администрирование → «Лицензия»: тариф компании, вид лицензии, срок и дней до окончания, использование лимитов (сотрудники, проекты, файлы, камеры, техника), какие разделы входят в тариф, история продлений и куда писать за продлением. Все действующие компании получили бессрочную лицензию «Бизнес» — ничего не изменилось в работе.',
      'За 30, 14 и 3 дня до окончания лицензии — плашка в шапке, дело в «Ждёт меня» и строка в утренней сводке администратору компании. После окончания — 14 дней льготного периода, затем портал переходит в режим «только чтение»: данные видны, выгрузки работают, изменения закрыты до продления. Разделы, не входящие в тариф, скрыты из меню; приглашение сотрудника, новый проект или файл сверх лимита тарифа — понятный отказ со ссылкой на страницу лицензии.',
      'Владелец портала (пункт меню «Владелец портала»): компании и состояние их лицензий, создание компании с пробным периодом и приглашением администратора, выпуск, продление, приостановка и возобновление лицензий, тарифы с разделами, лимитами и ценами, заявки на доступ, журнал действий. Данные компаний из кабинета не видны — только лицензии и счётчики.',
      'На странице входа — «Запросить доступ»: компания, которой ещё нет в портале, оставляет заявку с контактами и видит тарифы; владелец портала получает дело в «Ждёт меня», письмо и сообщение в Telegram и создаёт компанию из заявки одной кнопкой.',
    ],
  },
  {
    id: '2026-10-18-warehouse-consent-surplus',
    at: '2026-10-18T08:15:00Z',
    title: 'Склад: взять с чужого склада — с согласия владельца; излишки',
    modules: ['warehouse'],
    items: [
      'Подбор со склада: остатки всех складов компании видят все, кто видит склад или закупки, но взять позицию со склада другого проекта или с центрального можно только с согласия владельца склада — кладовщика, МОЛ или руководителя его проекта (решение владельца портала 18.10). Запрос появляется у владельца в «Ждёт вас по складу» и на вкладке «Резервы» (кнопки «Разрешить» и «Отказать» с причиной); после согласия резерв встаёт и создаётся черновик перемещения на склад проекта. Свой запрос можно отозвать, отказ виден с причиной.',
      'Излишки (СК-17): срок «без движения» — настройка компании (на вкладке «Отчёты», по умолчанию 90 дней); в отчёте «Позиции без движения» колонка «Кому нужна» — проекты, где та же позиция есть в утверждённой смете или открытой заявке на закуп. При закрытии объекта остатки его складов уходят черновиками перемещений на центральный склад (кнопка в карточке проекта — у потока 1).',
    ],
  },
  {
    id: '2026-10-18-psd-distribution',
    at: '2026-10-18T07:33:00Z',
    title: 'Рассылка ревизии с отметкой прочтения',
    modules: ['psd'],
    items: [
      'Карточка комплекта → блок «Рассылка» → «Разослать»: действующую ревизию можно отправить участникам проекта с правом на ПСД — всем сразу или выбранным. Рассылает тот, кто утверждает ревизии или ставит штамп.',
      'Сотрудник получает поручение «Ознакомиться» в «Ждёт меня» (оно попадает и в утреннюю сводку), внешний участник — плашку на карточке комплекта. Кнопка «Ознакомлен» или открытие любого файла ревизии отмечают прочтение и закрывают поручение.',
      'В блоке «Рассылка» видно, кто ознакомился и когда; «Напомнить» переносит поручение непрочитавшим на сегодня и считает напоминания — не чаще раза в час.',
    ],
  },
  {
    id: '2026-10-18-schedule-analysis',
    at: '2026-10-18T07:23:00Z',
    title: 'График: выравнивание ресурсов, риски сроков, анализ задержек, вид по пикетам',
    modules: ['schedule', 'resources'],
    items: [
      'Кнопка «Выровнять ресурсы»: задайте, сколько людей и техники доступно одновременно, — портал сдвинет работы с наибольшим резервом (в пределах резерва или со сдвигом окончания), покажет пики до и после и применит изменения одной правкой, которую можно откатить. Учитываются приоритет работы и фронт захватки.',
      'Вкладка «Риски сроков»: укажите в карточке работы оптимистичную и пессимистичную длительность — портал посчитает окончание с вероятностью 50, 80 и 90 %, вероятность уложиться в срок и какие работы чаще всего оказываются критическими.',
      'В «Базовых планах» — «Анализ задержек»: на сколько окончание ушло от базового плана и какая работа сколько в этом виновата, сдвиг окончания между версиями.',
      'Вид «время — местоположение» для водовода и дорог: у работы указываются пикеты начала и конца, на графике видно, где бригады догоняют друг друга.',
      'Назначение ресурса распределяется по длительности равномерно, в начале, в конце или колоколом.',
    ],
  },
  {
    id: '2026-10-18-warehouse-sourcing',
    at: '2026-10-18T07:10:00Z',
    title: 'Склад: подбор со склада перед закупкой',
    modules: ['warehouse'],
    items: [
      'На «Остатках» — «Подобрать со склада»: по названию, единице и количеству (или по строке заявки на закуп, ссылка /warehouse?line=…) портал находит ту же или похожую позицию на всех складах компании, в пути и у подрядчиков и показывает оценку совпадения с объяснением (100 — тот же код или название, 90–99 — тот же класс и свойства у другого производителя, 70–89 — отличается одно свойство). Цен в подборе нет.',
      '«Взять» и «Взять и переместить»: резерв под строку заявки (не больше, чем осталось по строке) и черновик перемещения на склад проекта — его проводит кладовщик склада-отправителя (дело «Ждёт вас по складу»), при приёмке резерв переезжает на склад-получатель, недостача остаётся «В пути» вместе с резервом; сторно возвращает резервы. Принятые замены запоминаются и в следующих заявках предлагаются первыми.',
    ],
  },
  {
    id: '2026-10-17-inspections-sheets',
    at: '2026-10-17T15:12:00Z',
    title: 'Освидетельствование скрытых работ и листы чертежей DWG и DXF',
    modules: ['supervision', 'psd'],
    items: [
      'Надзор → вкладка «Освидетельствование» → «+ Новый вызов»: подрядчик вызывает технадзор и авторский надзор на дату и время, указывает скрытые работы, лист ПСД, место, работу графика и следующую работу, правит чек-лист приёмки. Вызванный сотрудник получает поручение в «Ждёт меня».',
      'В карточке вызова надзор отмечает пункты чек-листа и подписывает акт — когда выполнено всё, — или отказывает с причиной. Фото работ и исполнительная схема прикладываются там же. Вызвавший может перенести или отменить вызов.',
      'Пока акт не подписан, следующая работа графика помечается «не начинать до подписанного акта»; запрет отметки начала в графике подключит раздел «График». Подпись ЭЦП — после подключения НУЦ РК.',
      'Чертёж DWG и DXF с несколькими листами: в просмотре переключатель «Модель / Лист 1 / Лист 2…» с названиями листов из чертежа — рамка, штамп и всё, что начерчено на листе.',
    ],
  },
  {
    id: '2026-10-17-budget-site-costs',
    at: '2026-10-17T14:53:00Z',
    title: 'Бюджет: затраты площадки и АУП',
    modules: ['budget'],
    items: [
      'В «Бюджет и маржа» — блок «Затраты площадки и АУП»: ФОТ ИТР, охрана, клининг, вода, ГСМ, ТО техники, питание, лизинг, аренда — суммой в месяц за период. Портал раскладывает их по разделам бюджета (пропорционально смете, поровну или долями вручную) и по месяцам, у каждого вида — статья финансового плана.',
      'Затраты площадки входят в плановую себестоимость и плановую маржу проекта; правятся только в черновике бюджета.',
    ],
  },
  {
    id: '2026-10-17-schedule-estimate',
    at: '2026-10-17T14:38:00Z',
    title: 'График: позиции сметы под работу, назначения по смете, запросы на изменение, стоимость версий',
    modules: ['schedule', 'resources'],
    items: [
      'В карточке работы — «Позиции сметы»: найдите позицию по шифру сметы, коду нормы или названию и привяжите к работе. Кнопка «Назначить людей, технику и материалы по смете» создаст назначения по нормам позиций.',
      'Утверждённый график возвращается в работу по утверждённому запросу на изменение из раздела «Изменения»; в параметрах графика можно сделать это обязательным. Основание видно у базовых планов.',
      'Сравнение базовых планов показывает стоимость работ по назначениям ресурсов (с уровнем денег «Акты» и выше).',
      'Карточку работника можно связать с сотрудником портала — тогда в ней видно инструмент и средства измерений, которые за ним числятся на складе.',
    ],
  },
  {
    id: '2026-10-17-warehouse-contractors',
    at: '2026-10-17T14:40:00Z',
    title: 'Склад: давальческие материалы у подрядчика',
    modules: ['warehouse'],
    items: [
      'Отчёт подрядчика о расходе давальческих: кладовщик вносит по складу «у подрядчика» израсходованное и норму по каждой позиции, перерасход сверх нормы подсвечивается; отчёт ждёт решения руководителя проекта и только после утверждения списывает материалы с подрядчика.',
      'Отчёт «Давальческие у подрядчиков»: что у подрядчика на руках, израсходовано, заявлено и перерасход сверх нормы с суммой к удержанию при оплате его актов (суммы — по уровню денег «Склад»). Остаток возвращается перемещением на склад проекта.',
    ],
  },
  {
    id: '2026-10-17-supervision-visits',
    at: '2026-10-17T14:11:00Z',
    title: 'Журнал посещений авторского и технического надзора',
    modules: ['supervision'],
    items: [
      'Надзор → вкладка «Журнал посещений»: каждый выезд авторского или технического надзора — запись с датой, объектом, организацией, участниками, целью и тем, что осмотрено. Кнопка «+ Новое посещение».',
      'В карточке посещения — «Добавить замечание»: замечание или указание выдаётся на этом посещении, с листом ПСД и местом, ответственный получает поручение со сроком. Выдавать на посещении может тот, кто его записал или был на нём.',
      'Блок «К проверке с прошлых посещений»: открытые замечания этого надзора по проекту. «Проверить» открывает замечание — закрытие или возврат на устранение попадают в запись текущего посещения, в блок «Проверено на посещении».',
      '«Подписать запись» закрывает запись посещения: дальше её не меняют и на ней не выдают замечаний; открыть снова может записавший.',
    ],
  },
  {
    id: '2026-10-17-estimates-offers-compare',
    at: '2026-10-17T13:58:00Z',
    title: 'Сметы: сравнение КП со сметой, демо-данные раздела',
    modules: ['estimates', 'budget'],
    items: [
      'В карточке сметы — вкладка «Сравнение с КП»: выбираете заявку на закуп и КП, портал сопоставляет позиции заявки с позициями смет по коду и словам, показывает цену КП без НДС против сметной цены и отклонение, итоги — по материалам, работам и оборудованию.',
      'В варианте «Субподряд по КП» (себестоимость раздела) КП выбирается из закупок проекта: сумма, НДС и поставщик подставляются сами.',
      'Для демо-компании готовы данные раздела: смета с нормами, раздел бюджета и варианты исполнения (подключаются общим сидом).',
    ],
  },
  {
    id: '2026-10-17-schedule-journal',
    at: '2026-10-17T13:38:00Z',
    title: 'График: откат правок, шаблоны фрагментов, ПСД под работу, сохранённые виды и Excel',
    modules: ['schedule'],
    items: [
      'Вкладка «Журнал правок»: кто, что и когда менял в графике. «Вернуть как было до неё» откатывает правку и все после неё; откат тоже попадает в журнал, и его можно отменить.',
      '«Шаблоны фрагментов»: типовые камера переключения, резервуар, участок водовода и участок дороги — вставляются за одно действие, объёмы и длительности считаются от длины или объёма. Любой узел ИСР можно сохранить шаблоном своей компании.',
      'В карточке работы — «ПСД и вопросы под работу»: привяжите комплект ПСД или вопрос к проекту. Если комплект ожидается позже начала работы или вопрос не закрыт, над диаграммой появится предупреждение.',
      'Предшественник из графика другого проекта: поиск по шифру проекта, коду или названию работы прямо в карточке.',
      '«Сохранённые виды»: шкала, отбор, группировка и вид графика — личные или общие для всей команды проекта.',
      'График загружается из Excel: выгрузка портала или таблица подрядчика с колонками «Код», «Работа», «Длительность», «Начало», «Предшественники».',
    ],
  },
  {
    id: '2026-10-17-warehouse-links',
    at: '2026-10-17T13:27:00Z',
    title: 'Склад: поступление по договору и «Ждёт вас по складу»',
    modules: ['warehouse'],
    items: [
      'Поступление от поставщика привязывается к его подписанному договору: в документе — ссылка на договор, по договору видно, что из спецификации получено и чего не хватает; когда всё получено, поставка в графике договора отмечается выполненной.',
      'Вверху склада — «Ждёт вас по складу»: выдачи, которые нужно подтвердить, заявленный расход и ведомости инвентаризации на решении руководителя проекта, инструмент к возврату, подтверждению и проверке в срок.',
    ],
  },
  {
    id: '2026-10-17-dwg-ifc-live',
    at: '2026-10-17T13:11:00Z',
    title: 'Чертежи DWG в браузере, модели IFC на рабочем портале',
    modules: ['psd'],
    items: [
      'Чертёж DWG открывается кнопкой «Открыть в просмотре» в карточке комплекта: портал переводит его в DXF и показывает со слоями, измерением и масштабом пальцами. Первый раз перевод занимает несколько секунд, дальше чертёж открывается сразу. Подлинник DWG — кнопка «Скачать». Файлы больше 100 МБ открываются скачиванием.',
      'Модели IFC в 3D теперь открываются и на рабочем портале: разбор идёт в отдельном потоке браузера, страница не замирает на большой модели. Выбранный элемент подсвечивается оранжевым, его свойства — под моделью.',
      'Незавершённые загрузки больших файлов частями, к которым не возвращались трое суток, закрываются ночью сами — части не занимают место в хранилище.',
    ],
  },
  {
    id: '2026-10-17-warehouse-poa',
    at: '2026-10-17T12:28:00Z',
    title: 'Склад: доверенность Д-1',
    modules: ['warehouse'],
    items: [
      'На вкладке «Документы» — «Доверенности Д-1»: кладовщик выписывает сотруднику доверенность на получение ТМЦ от поставщика (кому, удостоверение, от кого, по какому документу, что получить), печатная форма по приказу № 562 с QR и количеством прописью открывается сразу. После поступления — «Получено» со ссылкой на приходный документ; ненужная — «Аннулировать» с причиной; просроченные подсвечены.',
    ],
  },
  {
    id: '2026-10-17-notifications',
    at: '2026-10-17T11:56:00Z',
    title: 'Утренняя сводка дел на почту и в Telegram',
    modules: [],
    items: [
      'Каждое утро в 08:00 по часам компании портал присылает одним письмом и одним сообщением в Telegram, что ждёт вас: просроченное, срок сегодня и остальные дела из «Ждёт меня» со ссылками на карточки, а после выкладок — записи «Что нового» о ваших разделах. Если дел и новостей нет, сводка не приходит.',
      'Профиль → «Уведомления»: включить или выключить сводку и «Что нового» в ней, выбрать час (06:00–11:00) и каналы. Telegram подключается кнопкой «Подключить Telegram»: откройте бота по ссылке или пришлите ему код из восьми знаков — код действует 15 минут и подходит один раз. Там же «Отправить пробную сводку» и последние отправки.',
      'Суммы в письма и сообщения не включаются ни для кого — они видны в портале по уровню доступа к деньгам.',
      'Администратор компании в «Администрирование → Настройки» задаёт часовой пояс и час сводки по умолчанию, видит состояние почты и бота и журнал доставки: кому, когда, по какому каналу, дошло ли; недоставленное — первым.',
      'Чтобы сводки заработали на стенде, владелец портала указывает почтовый сервер (SMTP_URL, MAIL_FROM) и токен бота Telegram (TELEGRAM_BOT_TOKEN) в настройках сервера; до этого каналы помечены «не настроен».',
    ],
  },
  {
    id: '2026-10-17-budget-cost-variants',
    at: '2026-10-17T13:00:00Z',
    title: 'Бюджет: себестоимость раздела и варианты исполнения; сметы из АВС и Excel, PDF и KENML 2.01',
    modules: ['budget', 'estimates'],
    items: [
      'В «Бюджет и маржа» у каждого раздела — «себестоимость»: база из привязанных смет (трудоёмкость, материалы, оборудование, механизмы) и варианты исполнения — «Свои силы» от норм (трудоёмкость сметы, бригада, смена, ставка, начисления, проживание, питание, дорога, суточные), «Субподряд по КП» (сумма с НДС или без, материалы в КП или свои) и «Смешанный» (доля работ субподряду). По каждому варианту — расклад по видам затрат со статьями финансового плана и маржа.',
      'Вариант выбирается с обоснованием, и его сумма идёт в бюджет раздела. Вариант без материалов, без ставки, без доставки или без признака НДС считается, но не выбирается, пока пропуски не заполнены.',
      'Блок «Маржа проекта»: сметная маржа (смета − бюджет) и плановая по выбранным вариантам, разделы без варианта или с пропусками, расклад по видам затрат и статьям ФП.',
      'Сметы из АВС-KZ 2025.12 загружаются целиком: разделы и подразделы сметы, позиции-аналоги без ресурсов, оборудование по прайс-листу с отпускной ценой и заготовительно-складскими, округление половины тенге как в АВС. Разделы показываются заголовками в таблице позиций и блокируются по одному. Раздел бюджета можно указать сразу при загрузке KENML.',
      'Смету можно загрузить из Excel по форме 4* (.xls или .xlsx из АВС): позиции берутся как аналоги по стоимости единицы, оборудование — с отпускной ценой и заготовительно-складскими. В карточке сметы — кнопка «PDF» (печатная форма 4*) и «KENML 2.01» для госэкспертизы с проверкой обязательных реквизитов перед скачиванием.',
    ],
  },
  {
    id: '2026-10-17-warehouse-1c',
    at: '2026-10-17T11:28:00Z',
    title: 'Склад: обмен с 1С и перемещение по средней цене',
    modules: ['warehouse'],
    items: [
      'Вкладка «1С» на складе: проведённые документы к выгрузке в Excel или CSV для «Загрузки данных из табличного документа» — одна строка на позицию с кодами склада, номенклатуры, контрагента, МОЛ и договора. Портал показывает, каких кодов не хватает. Статусы «к выгрузке», «выгружен», «проведён в 1С» с номером и датой документа 1С.',
      'Коды 1С: номенклатуры — в карточке позиции (с подсказкой из загруженного справочника), склада — в карточке склада, контрагентов, договоров и МОЛ — в «Кодах 1С». Справочники 1С загружаются файлом; контрагентам код подставляется по БИН, складам — по названию.',
      'Сверка поступлений: файл из 1С с контрагентом, номером, датой и суммой сверяется с поступлениями портала — что сошлось, где расходится сумма, чего нет в портале и чего нет в 1С.',
      'Перемещение и передача подрядчику проводятся по средней цене прихода склада-отправителя — себестоимость переходит на склад-получатель. Передача между проектами разных юрлиц помечается внутригрупповой и печатается как накладная на сторону (З-2).',
    ],
  },
  {
    id: '2026-10-17-dxf-ifc-compare',
    at: '2026-10-17T11:25:00Z',
    title: 'Чертежи DXF, модели IFC в 3D и сравнение ревизий листа',
    modules: ['psd'],
    items: [
      'Чертёж DXF открывается в портале: слои включаются и выключаются, масштаб колесом мыши или двумя пальцами, «Измерить» — расстояние между двумя точками в единицах чертежа. Блоки, дуги и тексты на месте.',
      'Модель IFC — в 3D прямо в браузере: вращение, нажатие на элемент показывает его свойства, системы и элементы скрываются по типам, разрез по высоте.',
      'Сравнение ревизий листа: «Сравнить ревизии» на странице листа — что добавлено, видно зелёным, что удалено — красным.',
      'У файлов DXF и IFC в карточке комплекта — «Открыть в просмотре». DWG пока открывается скачиванием: просмотр появится после настройки сервера.',
    ],
  },
  {
    id: '2026-10-17-schedule-impact',
    at: '2026-10-17T11:04:42Z',
    title: 'График: последствия сдвига, трассировка логики, сетевой график, печать и Excel',
    modules: ['schedule'],
    items: [
      'В карточке работы — «Что будет, если сдвинуть работу»: укажите сдвиг в рабочих днях и увидите, что изменится — окончание проекта, вехи, крайние сроки и сроки договоров, платежи и поставки по договорам, заявки на закуп, пик людей и техники. Это расчёт «что если», график не меняется.',
      'Там же — «Закупки под работу»: привяжите заявку на закуп, и при сдвиге работы будет видно, успевает ли заявка к дате потребности.',
      'Выберите работу — появится «Логика от …»: предшественники, последователи или обе стороны, все связи или только ведущие. На диаграмме останутся только эти работы; нажмите на другую работу в трассе — логика построится уже от неё.',
      '«Пути резерва к работе» — цепочки работ, которые держат выбранную, от ведущей (с наименьшим резервом) к остальным; нажмите на путь, чтобы показать его на диаграмме.',
      'Новый вид «Сетевой график»: работы блоками по порядку логики со сроками и резервом, ведущие связи — сплошной линией, критические работы — красной рамкой.',
      '«Скачать график» → «Excel» — таблица работ по ИСР с полосами по неделям и листом связей; «PDF для печати…» — листы A4–A1 с легендой, штампом и подписями «Составил, Проверил, Утвердил».',
    ],
  },
  {
    id: '2026-10-17-warehouse-forms-issue',
    at: '2026-10-17T10:26:00Z',
    title: 'Склад: печатные формы с QR, подтверждение выдачи, расход и потери',
    modules: ['warehouse'],
    items: [
      'Печатные формы по приказу Минфина РК № 562 с QR для проверки подлинности: З-1 приходный ордер, З-2 накладная на отпуск на сторону, З-4 акт оприходования от демонтажа, З-5 накладная на внутреннее перемещение, З-6 акт списания — кнопка «Печатная форма» в проведённом документе; З-3 карточка учёта запасов — в карточке позиции по каждому складу; З-7 ведомость остатков — в карточке склада.',
      'Выдача на работу теперь числится за получателем только после его подтверждения: получатель открывает документ выдачи и указывает фактически полученное, недополученное возвращается на склад. На вкладке «На руках» видно подтверждённое и то, что ждёт подтверждения.',
      'Израсходованное, потерю, поломку или недостачу сотрудник заявляет сам («На руках» → «Заявить расход или потерю»); документ ждёт решения руководителя проекта, до решения ни склад, ни остаток на руках не меняются. РП утверждает — списывается с рук, или отказывает с причиной.',
    ],
  },
  {
    id: '2026-10-17-sheet-viewer',
    at: '2026-10-17T10:15:00Z',
    title: 'Просмотр листа с пометками и точками, файлы до 2 ГБ, водяной знак',
    modules: ['psd', 'supervision'],
    items: [
      'Лист ПСД открывается прямо в портале — на компьютере, планшете и телефоне: страницы, масштаб, без сторонних программ и облачных сервисов.',
      'Пометки на листе: облако, стрелка, текст, размер. Пока пометка не опубликована, её видите только вы; на погашенной ревизии пометки закрыты для правки, а при выпуске новой ревизии открытые пометки переходят на неё с отметкой «проверить актуальность».',
      'Вопросы и замечания ставятся в точку листа: «Точка: вопрос или замечание» → нажмите на место. Точки видны на листе и ведут в карточку.',
      'Файлы ПСД до 2 ГБ загружаются частями с докачкой: если связь прервалась, выберите тот же файл — загрузка продолжится с места обрыва.',
      'Скачанный лист PDF получает водяной знак: кто и когда скачал. Каждое открытие и скачивание по-прежнему пишется в журнал.',
    ],
  },
  {
    id: '2026-10-17-resources',
    at: '2026-10-17T10:04:17Z',
    title: 'Ресурсы: загрузка людей и техники из графика, персонал с допусками, вахты и табель',
    modules: ['resources', 'schedule'],
    items: [
      'В карточке работы графика — ресурсы: люди по профессиям и разрядам, техника и материалы; количество одновременно, норма на единицу объёма или всего на работу. Трудоёмкость считается сама, стоимость видна с уровнем денег «Акты» и выше.',
      'Раздел «Ресурсы» → «Загрузка»: пик людей и машин по неделям по проекту или по всем проектам; красным — где нужно больше, чем на вахте. Ниже — стоимость по неделям: ФОТ с начислениями и суточными, техника, материалы. Ресурсы без ставок показываются отдельно, чтобы внести их до утверждения себестоимости.',
      'Справочник ресурсов: профессии и разряды с нужными документами, бригады с составом, техника, материалы; ставки — версиями с датой действия.',
      'Персонал: допуски, удостоверения, медосмотры и инструктажи со сроками; истёкшие и недостающие видны в списке. Человека без действующих документов профессии на работу назначить нельзя.',
      'График загружается и выгружается в форматах Primavera P6: XER и P6 XML, вместе с календарями, ИСР, связями и фактом; после загрузки — отчёт, где даты файла разошлись с расчётом портала.',
      'Вахты 15/15 и 28/28 с отметкой заезда и выезда и подсветкой пересечений; табель за месяц с согласованием — правка часов после согласования помечает его устаревшим; план мобилизации с подсказкой, кого не хватает по графику.',
    ],
  },
  {
    id: '2026-10-17-estimates-editing',
    at: '2026-10-17T10:30:00Z',
    title: 'Сметы: составление в портале, проверка, пересчёт и выгрузка',
    modules: ['estimates', 'norms'],
    items: [
      'В карточке сметы — «Новая позиция»: работа по норме ЭСН с составом ресурсов и ценами действующих выпусков, материал или оборудование из сборника цен, прайсовая позиция по КП (цена с НДС приводится к уровню сметных цен: НДС, заготовительно-складские, К приведения) и прочие затраты. Ресурс позиции заменяется с обоснованием, у коэффициентов — название и обоснование.',
      'Объектная смета и сводный расчёт складываются из входящих локальных смет; вкладка «Проверка» показывает арифметику, дубли, пропущенные коэффициенты, ресурсы без цены и цены не из действующего выпуска.',
      '«Пересчитать в новый уровень цен»: новая версия сметы с ценами из выбранных выпусков и отчёт, какие позиции изменились и каких ресурсов в выпуске нет.',
      'Выгрузка сметы в Excel по форме с ресурсами и ресурсной ведомостью и в KENML 1.0 для АВС-KZ, Сметы РК и SANA.',
      'Нормы и цены подставляются только из выпусков со статусом «действует»: статус подтверждает сметный отдел в нормативной базе.',
    ],
  },
  {
    id: '2026-10-17-warehouse-inventory-tools',
    at: '2026-10-17T09:23:00Z',
    title: 'Склад: инвентаризация, инструмент и отчёты',
    modules: ['warehouse'],
    items: [
      'Инвентаризация: снимок учёта делается в момент начала, склад продолжает работать — ожидаемое количество при вводе равно снимку плюс движения после него. Пересчёт со списка или с телефона по QR на этикетке (поле ввода прямо в карточке позиции); пустое поле означает «не проверено», а не ноль. Ведомость расхождений утверждает руководитель проекта, корректировки проводятся документом «Инвентаризация» только по проверенным строкам и ссылаются на ведомость. При смене МОЛ инвентаризация начинается сама; склады без проверки больше квартала показаны сверху вкладки.',
      'Инструмент, средства измерений, такелаж и оборудование — поштучно: карточка экземпляра с инвентарным и серийным номером, моделью, складом, у кого и с какого числа, комплектом, датой возврата, состоянием и историей; этикетка с QR на экземпляр.',
      'Выдача: кладовщик выбирает сотрудника и срок, получатель подтверждает в своём приложении — только тогда инструмент числится за ним. Подрядчику — по акту с датой возврата. «Что на руках» и просроченные возвраты — фильтрами на вкладке «Инструмент».',
      'Проверки по видам: поверка средств измерений, проверка изоляции и холостого хода, осмотр такелажа с биркой, ТО оборудования по дням. За 7 дней до срока — пометка «скоро», после срока выдача закрыта до записи о новой проверке.',

      'Вкладка «Отчёты»: остатки на дату (на конец месяца — сохранённый снимок), движение за период, отчёт МОЛ, резервы, позиции без движения, инструмент на руках, сроки проверок, пополнение расходников по неснижаемому запасу — на экране и в Excel; суммы только с уровнем денег «Склад».',
    ],
  },
  {
    id: '2026-10-17-changes',
    at: '2026-10-17T09:15:00Z',
    title: 'Изменения: запрос, анализ влияния, маршрут по сумме, итог и тренд',
    modules: ['changes', 'supervision'],
    items: [
      'Раздел «Изменения»: запрос ИЗ-0001 — что меняется (ПСД, смета, ТМЦ, подрядчик, график, договор), класс (в пределах договора, за счёт заказчика, за счёт резерва, перераспределение), инициатор, за чей счёт, причина и основание, цена, себестоимость и срок.',
      'Анализ влияния по связям: затронутые комплекты ПСД с действующей ревизией и открытыми вопросами, договоры со статусом, суммой и сроком, заявки на закуп, вехи.',
      'Маршрут собирается сам: ПТО, сметчик (если меняются деньги), руководитель проекта; ФП и ДДС — финансовый менеджер (узнаёт сразу) и куратор; свыше лимита — Директор; затем проектировщик и заказчик. Автор не согласует свой запрос, один человек решает один шаг.',
      'Мелкое изменение в пределах лимита (по умолчанию 2 % стоимости позиции) утверждается без маршрута с записью в ходе; лимиты задаёт администратор.',
      'После утверждения ответственным ставятся поручения: выпустить новую ревизию комплекта, подготовить допсоглашение, обновить смету, бюджет, ФП, решить по базовому плану.',
      'Итог и тренд: утверждённые и неутверждённые изменения отдельно, риск «работы идут, допсоглашения нет», накопленный итог по датам, по видам и инициаторам. Суммы — только с уровнем «Все деньги»; заказчик видит изменения за его счёт без себестоимости.',
      'Принятый ответ проектировщика, меняющий проект, сам создаёт черновик запроса с листом вопроса; из указания авторского надзора запрос создаётся кнопкой. Замечания теперь нумеруются ЗАМ-0001, чтобы не путать с заявками на закуп.',
    ],
  },
  {
    id: '2026-10-17-schedule',
    at: '2026-10-17T09:02:32Z',
    title: 'График: собственный расчёт критического пути и диаграмма Ганта',
    modules: ['schedule'],
    items: [
      'Раздел «График»: графики всех проектов со сроком окончания, отклонением от базового плана и процентом выполнения. График создаётся пустым или из примера (камера, водовод, резервуар) и загружается из MS Project XML.',
      'Диаграмма Ганта: шкала от часов до кварталов, критический путь красным, резервы, связи, вехи, базовый план под работой, линия даты отчёта. Полосу можно перетащить (работа получит ограничение «начало не ранее»), растянуть или связать с другой работой; правка пересчитывается сразу, Ctrl+Z и Ctrl+Y отменяют и повторяют.',
      'Карточка работы: тип (работа, вехи, уровень усилий, гамак), длительность — задана или от объёма и выработки звена, календарь, ограничения дат и крайний срок, факт, ответственный, подрядчик, захватка, свои коды, предшественники и последователи с задержкой в днях, часах или процентах. Пока карточка открыта, работу не может править другой.',
      'Календари: 5/2, 6/1, две и три смены, вахта 15/15 и 28/28, праздники и переносы РК, исключения и сезонные ограничения (например, бетонирование в мороз).',
      'Базовые планы: до 10 версий, основной, сравнение любых двух версий и текущего графика. Утверждённый график меняется только по факту; сроки и логика — после возврата в работу с причиной.',
      'Проверка качества графика по 14 пунктам DCMA и параметры расчёта уровня Primavera: сохранение логики или приоритет факта, дата отчёта, способ расчёта резерва и критического пути.',
    ],
  },
  {
    id: '2026-10-17-estimates-norms',
    at: '2026-10-17T10:00:00Z',
    title: 'Сметы из KENML и нормативная база',
    modules: ['estimates', 'norms', 'budget'],
    items: [
      'Раздел «Сметы»: сметы проекта загружаются из АВС-KZ, Сметы РК и SANA в формате KENML 1.0. Портал пересчитывает каждую позицию по ресурсам, нормам и коэффициентам и показывает расхождения с файлом — смета с расхождениями не утверждается.',
      'В карточке сметы — итоги по видам затрат, ФОТ и трудоёмкость, позиции с составом ресурсов и коэффициентами, версии (проектная, после экспертизы, договорная, рабочая, на допработы) и сравнение двух версий построчно, ресурсная ведомость по смете, объекту и проекту.',
      'Смета привязывается к разделу бюджета: во вкладке «Бюджет и маржа» видно сметную стоимость против плановой себестоимости и сметную маржу по разделам.',
      'Раздел «Нормативная база»: выпуски сборников с годом, ценовой зоной и статусом действия, нормы ЭСН с составом ресурсов и ценами, поиск по коду и обычными словами, карточка нормы с историей цен, аналогами и сметами, где она применена; список документов, которых не хватает на Диске.',
      'Суммы смет видят сотрудники с уровнем денег «Акты и счета» и выше; без него видны позиции и объёмы.',
    ],
  },
  {
    id: '2026-10-17-warehouse',
    at: '2026-10-17T08:23:00Z',
    title: 'Склад: склады, каталог ТМЦ, документы и остатки',
    modules: ['warehouse'],
    items: [
      'Раздел «Склад» открыт: справочник складов (центральный, приобъектный, открытая площадка, инструментальная, у подрядчика; «В пути» портал ведёт сам), единый каталог ТМЦ с кодом, классом АГСК-3, свойствами, единицей и пересчётом (тонны в метры), требованиями к сертификату и паспорту. При вводе новой позиции портал показывает похожие с оценкой совпадения и сам ничего не объединяет.',
      'Документы: поступление, остаток на начало, оприходование от демонтажа, перемещение, передача подрядчику, выдача на работу, возврат, списание с причиной и сторно. Документ создаётся черновиком, остаток меняет только проведение; проведённый документ не правится — ошибка исправляется сторно с причиной. Повторная отправка формы не создаёт второй документ, уход в минус запрещён.',
      'Остаток, «на входном контроле», резерв и «доступно» считаются из журнала движений одной функцией: на вкладке «Остатки», в карточке позиции и в карточке склада. Ручной резерв под работу — с причиной, закрывается выдачей.',
      'Перемещение идёт через склад «В пути»: отправитель проводит, кладовщик склада-получателя подтверждает принятое по строкам; недостача остаётся «В пути» и видна отправителю.',
      'Позиция, которой нужен сертификат или паспорт, после поступления стоит «на входном контроле» и не выдаётся, пока сотрудник с правом «Вести проверки» не примет решение «принято» или «брак».',
      'Выдача на работу переводит материалы на получателя — вкладка «На руках» показывает, что числится за сотрудниками; возврат снимает.',
      'Этикетки с QR на позицию и на упаковку из поступления: лист A4 на 8 этикеток, термопринтер 100×70 и 58×40 мм; скан QR открывает карточку позиции.',
      'Цены прихода и суммы документов видят и вносят сотрудники с уровнем денег «Склад» и выше; остальным суммы в основании и примечаниях показываются с маской.',
    ],
  },
  {
    id: '2026-10-17-update-notices',
    at: '2026-10-17T10:00:00Z',
    title: 'Предупреждение за 5 минут до обновления портала',
    modules: [],
    items: [
      'За 5 минут до выкладки новой версии на всех страницах и на входе появляется плашка с отсчётом: сохраните то, что вводите. Во время выкладки — «Идёт обновление», портал сам проверяет связь каждые 10 секунд; после — «Вышла новая версия портала» с кнопкой «Обновить страницу» и ссылкой «Что нового». Страница сама не перезагружается: введённое не пропадает.',
      'Выкладка идёт только после успешных автоматических проверок и не раньше объявленного времени.',
      'Администратор компании в «Администрирование → Настройки» предупреждает сотрудников о плановых работах: когда начнутся, сколько продлятся и что будет.',
    ],
  },
  {
    id: '2026-10-17-payment-calendar',
    at: '2026-10-17T09:00:00Z',
    title: 'Платёжный календарь, комплекты документов к оплате, проверка повторной оплаты',
    modules: ['finance', 'procurement', 'contracts'],
    items: [
      'Новый раздел «Финансы» — платёжный календарь компании и проекта: плановые платежи из графиков подписанных договоров и заявки на оплату, которые их закрывают, по дням и неделям, с очерёдностью и источником денег. Календарь проекта открывается со вкладки «Финансы» проекта.',
      'Финансовый менеджер задаёт лимиты платежей дня и недели на всю компанию: дни, где платежи с плановыми выше лимита, выделяются, а заявка на оплату, с которой переданные и оплаченные платежи дня или недели выше лимита, при передаче ждёт его решения. Перенос переданной заявки на такой день — тоже его решение.',
      'Заявка на оплату ссылается на плановый платёж договора: если открытый платёж один, сумма и дата подставляются сами; можно выбрать «вне графика». Заявки, поданные раньше, и оплаты, внесённые без заявки по договору, закрывают график по порядку — оплаченное не всплывает как неоплаченное. Перенос даты после передачи — только с причиной.',
      'Справочник «Комплекты документов к оплате»: какие документы нужны по виду договора и типу платежа. В заявке на оплату к каждому документу прикладывается файл; по настройке финансового менеджера документ считается полученным только с файлом. Гарантия возврата аванса — если договор её требует; после отправки договора на согласование отметку меняет финансовый менеджер с причиной.',
      'Если у контрагента уже есть поданная или оплаченная заявка на ту же сумму с тем же счётом или назначением (у старых заявок — по тому же договору) или такая же оплата без заявки, новая заявка ждёт решения финансового менеджера юрлица или компании с причиной; снимает остановку не тот, кто готовил или передавал заявку. Без номера счёта или назначения заявка на оплату не передаётся.',
      'В карточке договора — «Документы по договору» и сколько по каждому плановому платежу уже в заявках и оплачено.',
      'Договоры и заявки одного контрагента на сходный предмет, каждая до порога трёх КП, а вместе выше, помечаются до согласования. Окно проверки — в «Администрирование → Настройки».',
    ],
  },
  {
    id: '2026-10-17-psd-supervision',
    at: '2026-10-17T09:00:00Z',
    title: 'ПСД по шифрам и ревизиям, единый реестр замечаний и вопросы к проекту',
    modules: ['psd', 'supervision'],
    items: [
      'Раздел «ПСД»: комплекты заводятся по шифру вида 227-23-РП-ВВ-1-КЖ — портал сам разбирает стадию, объект и марку и сверяет объект с объектами проекта. Шифр с ошибкой (например, «ОХЗ-1» вместо «ОЗХ-1») отправляет комплект в карантин: он не выпускается, пока шифр не исправят. Правило шифра задаётся на проект.',
      'Ведомость листов проверяется на пропуски и дубли. Ревизии R00, R01… идут по статусам: в разработке → на проверке → замечания или утверждено → «В производство работ». Штамп ставит ГИП; прежняя ревизия гасится в момент штампа на новую.',
      'Прораб и подрядчик видят только действующую ревизию: черновики, проверка и аннулированные им не показываются. Каждое открытие и скачивание листа записывается в журнал.',
      'Накладные: входящая от проектировщика — состав, экземпляры, бумажные оригиналы и отметка получения; исходящая — ревизии на момент отправки. В реестре видно, какие комплекты просрочены проектировщиком.',
      'Раздел «Надзор и вопросы»: один реестр для технадзора, авторского надзора, экспертизы, заказчика, ОТК, ОТ и ПБ, экологии и строителей. Предписание — с нормой, листом, фото «до» и «после», сроком и остановкой работ; ответственный получает поручение в «Ждёт меня». Закрывает только выдавший или человек с его ролью, с коренной причиной; подрядчик может оспорить с обоснованием. Внутренние замечания ОТК подрядчику не видны.',
      'Вопросы к проекту ВП-001: ПТО проверяет и объединяет одинаковые → проектировщик отвечает → ПТО принимает, уточняет или передаёт заказчику. Срок ответа — в рабочих днях РК с праздниками, видно, на чьей стороне вопрос. Уточнение получает номер ВП-001.1. На странице листа прораб видит все вопросы, ответы и замечания по нему.',
      'Вкладка «Сроки и просрочки»: открытые и просроченные замечания по источникам и подрядчикам, средний срок устранения и ответа проектировщика.',
    ],
  },
  {
    id: '2026-10-17-roadmap',
    at: '2026-10-17T08:00:00Z',
    title: 'Ход разработки: что сделано и где, что ещё нет и почему',
    modules: [],
    items: [
      'На странице «Ход разработки» у каждого требования ТЗ теперь три ответа: где оно работает в портале (ссылка на страницу и место на ней), когда ожидается (дата выкладки или этап плана) и почему его ещё нет — ждёт своего этапа, зависит от другого раздела, ждёт решения или серверов заказчика, переделывается под новую редакцию ТЗ или проверяется при приёмке.',
      'Реестр сверен с редакцией ТЗ в Google Docs от 17.10.2026: 626 требований, из них 66 новых (отмечены «новое в ТЗ»). Фильтры — по причине, статусу «ещё не сделано целиком» и новым требованиям; сверху — сколько готово, частично, ещё нет и сколько ждёт заказчика.',
      'План этапов уточнён: склад и финансы, качество и документы, интеграции с 1С, аналитика и Pilot, серверы в Казахстане и приёмка первой очереди стали отдельными этапами 9–14, а вторая и третья очередь — этапом 15; у каждого этапа написано, что нужно заранее со стороны заказчика.',
      'Те же данные отдаёт API /api/v1/roadmap — для отчётов заказчику.',
    ],
  },
  {
    id: '2026-10-17-approvals-by-department',
    at: '2026-10-17T07:00:00Z',
    title: 'Согласование по подразделениям, защита сумм, удобнее на телефоне',
    modules: [],
    items: [
      'Каждый согласует свою часть маршрута договора и допсоглашения: бухгалтерия, юридическая служба, заместитель директора и служба безопасности — по своим ролям; роль «Согласующий договоров» остаётся для замещения. Автор проекта решает только пункт инициатора. Если пункт некому решить, карточка договора подскажет, какую роль назначить.',
      'Допсоглашение, которое меняет сумму, цены, графики или порядок оплаты, согласует сотрудник, который видит суммы договоров. Решение по пункту прошлого раунда не проходит, а карточка договора обновляется, когда вы возвращаетесь на вкладку.',
      'На повторном согласовании допсоглашения видно, что изменилось с прошлого раунда; подписывается та редакция, которую открыл подписант. Отмена допсоглашения на согласовании — с причиной.',
      'Сумма договора по допсоглашению не может стать меньше уже поданных заявок на оплату, а оплата не отмечается сверх суммы договора — даже по заявке, переданной раньше. Такие заявки видны предупреждением в карточке договора.',
      'Порог проверки службой безопасности (15 %) считается от исходной суммы договора или от суммы после её последней проверки. В допсоглашении можно указать или сменить статью ФП.',
      'Без доступа к суммам тексты с суммами — порядок оплаты, обоснования, комментарии, условия КП — видны с маской и открыты только для чтения: сохранение формы их не затирает. Маска понимает «тенге», «тг», KZT, $, €, суммы с запятыми и крупные числа без валюты, а количества («12 000 шт»), номера документов и ГОСТы оставляет как есть.',
      'Суммы вносит тот, кто их видит: КП с ценами, заявку на оплату, факт оплаты, спецификацию с ценами и платежи графика — сотрудник с уровнем денег «Акты и счета» или выше; без него в графике договора правится только поставка.',
      'Если допсоглашение переносит договор на другую статью ФП, неоплаченные заявки на оплату и заявка на закуп переходят на неё же.',
      'На телефоне спецификация договора — карточками, у широких таблиц закреплён первый столбец и есть подсказка о прокрутке, вкладки проекта прокручиваются к открытой, кнопки «назад» и «вперёд» крупнее и гаснут, когда идти некуда.',
      'История изменений — словами: разделы, поля, статусы и имена сотрудников вместо кодов. Даты по умолчанию и сроки — по часам Астаны.',
    ],
  },
  {
    id: '2026-10-17-navigation',
    at: '2026-10-17T05:00:00Z',
    title: 'Назад, вперёд и «где вы находитесь» на каждой странице',
    modules: [],
    items: [
      'Вверху каждой страницы — кнопки «назад» и «вперёд» и строка «где вы находитесь»: раздел, проект и документ, например «Договоры / 227-23-ВВ2 / П-2026/029». Звенья строки — ссылки.',
      'Если карточка открыта сразу по ссылке из «Ждёт меня» или уведомления, «назад» ведёт на уровень выше — в проект или раздел.',
      'Вкладки закупок (заявки, реестры, заявки на оплату) попадают в адрес страницы: «назад» и «вперёд» их переключают, ссылку можно переслать.',
      'На телефоне строка «где вы находитесь» — отдельной полосой под шапкой; широкие таблицы прокручиваются внутри своих блоков, а страница не уезжает вбок.',
      'Подписать согласованный договор нужно в течение 2 рабочих дней: срок виден в «Ждёт меня», просрочка выделяется.',
      'Финансовый отдел готовит заявки на оплату, подписант видит закупки — по матрице прав новой редакции ТЗ.',
    ],
  },
  {
    id: '2026-10-17-amendments',
    at: '2026-10-17T04:00:00Z',
    title: 'Допсоглашения и сравнение версий договора',
    modules: ['contracts', 'procurement'],
    items: [
      'К подписанному договору оформляется допсоглашение: новая сумма, срок окончания, порядок оплаты, спецификация и графики — с причиной, например новой ревизией ПСД или допработами.',
      'Допсоглашение повторно согласуют затронутые подразделения: юристы — всегда, бухгалтерия — если меняются сумма, цены или оплата, заместитель директора — если меняются условия, служба безопасности — при смене руководителя, участников или бенефициаров контрагента и при изменении суммы от 15 %.',
      'После подписания допсоглашения карточка договора обновляется сама, а прежние условия остаются в допсоглашении: это история версий договора.',
      'Оплаты по договору не могут превысить его сумму: доплата — после подписанного допсоглашения, а если сумма выходит за статью — после новой версии ФП. Согласования оплаты сверх договора больше нет.',
      'Когда проект договора отправляют на согласование повторно, каждый согласующий видит, что изменилось с прошлой версии, и подтверждает изменения своим решением.',
      'В «Ждёт меня»: согласование и подписание допсоглашений, возвращённое допсоглашение — с комментарием.',
    ],
  },
  {
    id: '2026-10-17-tz-rules',
    at: '2026-10-17T03:00:00Z',
    title: 'Правила закупок и договоров по новой редакции ТЗ',
    modules: ['procurement', 'contracts', 'budget', 'suppliers'],
    items: [
      'Остаток статьи ФП проверяется дважды: на проверке заявки — по смете, при выборе поставщика — по цене КП. Если сумма выше остатка, сбор КП продолжается, а договор уйдёт на согласование после утверждения новой версии ФП.',
      'Без пояснения, почему выбраны этот контрагент и эта цена, договор не уходит на согласование; если цена выше рыночной по истории закупок, это видно согласующим.',
      'Порог 300 000 ₸ для трёх КП считается по сумме договора, то есть по цене выбранного КП.',
      'Новую статью расходов запрашивают на странице «Статьи расходов»: финансовый менеджер проверяет, Директор утверждает, и статья сразу появляется во всех формах.',
      'ПТО подтверждает объёмы финансового плана без сумм: строки плана, месяцы и объёмы из карточки проекта.',
      'В стоп-лист вносит и снимает с него Директор. Права ролей сверены с матрицей прав приложения В ТЗ.',
    ],
  },
  {
    id: '2026-10-17-finplan-payments',
    at: '2026-10-16T21:20:00Z',
    title: 'Финансовый план и оплаты: остаток статьи, возвраты, следующие шаги',
    modules: ['budget', 'procurement'],
    items: [
      'Оплата сверх договора, согласованная по ЗК-15, уменьшает остаток статьи ФП: обязательство по договору — большее из суммы договора и оплаченного.',
      'Оплату сверх договора согласует тот, кто видит её сумму (уровень денег «Акты и счета» и выше).',
      'В «Ждёт меня»: ФП, возвращённый на доработку, — с причиной; «Создать заявку на оплату», когда реестр передан в финансы, а заявки на оплату ещё нет.',
      'Вкладка ФП открывается на версии в работе — черновике или версии на проверке; утверждённая версия — рядом, на переключателе версий.',
    ],
  },
  {
    id: '2026-10-17-flow',
    at: '2026-10-16T21:00:00Z',
    title: 'Договор готовит руководитель проекта; правка заявки после возврата',
    modules: ['procurement', 'contracts'],
    items: [
      'Руководитель проекта и документолог оформляют договор по выбранному КП и расходный договор без заявки — раньше это мог только администратор.',
      'Возвращённую заявку можно исправить кнопкой «Изменить заявку» и отправить на проверку снова; причина возврата видна вверху заявки. Сметные цены, которые вам не видны, при правке сохраняются.',
      'В «Ждёт меня»: проект договора, который ещё не отправлен на согласование, возвращённый или отклонённый договор, подписание доходного договора для подписанта компании, передача реестра в финансы, принятие проекта финансовым менеджером после подписания доходного договора.',
      'Кнопки согласования договора видны только на пунктах, которые вы вправе решить; в раунде один человек решает один пункт.',
    ],
  },
  {
    id: '2026-10-17-contracts',
    at: '2026-10-16T20:25:00Z',
    title: 'Новый договор и сроки договоров',
    modules: ['contracts'],
    items: [
      'На странице «Договоры» — кнопка «Новый договор»: доходный с заказчиком (например, 227-23) или расходный без заявки на закуп.',
      'Доходный договор подписывает подписант компании или юрлица без маршрута из пяти согласующих; подписанный договор с суммой открывает проект для заявок.',
      'За 30 дней до окончания срока договора — дело в «Ждёт меня» ответственному и документологу.',
    ],
  },
  {
    id: '2026-10-16-review4',
    at: '2026-10-16T20:50:00Z',
    title: 'Стоп-лист, контрагенты, служебные записки; тёмная тема',
    modules: [],
    items: [
      'Контрагент из стоп-листа не проходит дальше выбора: заявка с ним не идёт на согласование, договор не создаётся, не согласуется и не подписывается.',
      'Карточка контрагента показывает КП, договоры и оплаты только по проектам, которые вам открыты.',
      'Проект до доходного договора открывается для заявок только настоящим договором с заказчиком: с суммой и после маршрута согласования.',
      'Обязательства по одобренной служебной записке — не больше её суммы.',
      'Баллы КП считаются только по КП, которые можно выбрать; в файле коммерческого анализа видно, кто не участвует в выборе.',
      'Тот же поставщик, записанный иначе («ТОО «…»»), находится и не заводится второй раз.',
      'Тёмная тема — в профиле, раздел «Оформление».',
    ],
  },
  {
    id: '2026-10-16-safety',
    at: '2026-10-16T19:40:00Z',
    title: 'Права и деньги после проверки, профиль, печать, телефон',
    modules: [],
    items: [
      'Проект переводится со стадии подготовки или тендера только после подписания доходного договора или решением Директора; новый проект без договора начинается с подготовки или тендера.',
      'Служебную записку об обязательствах до договора решает Директор, автор записки по ней не решает; новая записка подаётся только после отказа.',
      'Суммы скрыты по уровню доступа к деньгам и в истории изменений, в обзоре закупок, в карточке проекта и в «Ждёт меня».',
      'Карточка проекта и поручения — только для сотрудников компании; внешние участники их не видят.',
      'В профиле — кнопка «Выйти на других устройствах».',
      'Списки и карточки печатаются на А4 без меню.',
      'На телефоне заголовки, длинные названия и таблицы больше не обрезаются.',
    ],
  },
  {
    id: '2026-10-16-scoring',
    at: '2026-10-16T19:01:00Z',
    title: 'Закупки: баллы КП и файл коммерческого анализа',
    modules: ['procurement'],
    items: [
      'КП получают баллы по критериям с весами: цена с доставкой, срок поставки, аванс и отсрочка, документы и стоп-лист, полнота.',
      'Веса меняются только с обоснованием; выбор не лучшего по баллу КП требует пояснения.',
      'Файл коммерческого анализа в Excel формируется сам: цены по позициям, итоги, сравнение со сметой, баллы, выбор и пояснение.',
      'В КП отмечаются исключения и позиции сверх запроса — они не входят в сумму сравнения.',
    ],
  },
  {
    id: '2026-10-16-suppliers',
    at: '2026-10-16T18:57:00Z',
    title: 'Поставщики и контрагенты',
    modules: ['suppliers', 'procurement'],
    items: [
      'Единый реестр контрагентов группы: роли, категории ТМЦ и работ, регионы, реквизиты; БИН не повторяется, при заведении портал показывает похожих.',
      'Документы со сроком действия: за 30 дней до окончания — дело в «Ждёт меня», истёкшие отмечаются в закупках и договорах.',
      'Стоп-лист с причиной и решением руководителя: из стоп-листа КП не принимаются.',
      'В карточке контрагента — его КП, договоры и оплаты.',
    ],
  },
  {
    id: '2026-10-16-inbox',
    at: '2026-10-16T18:43:00Z',
    title: '«Ждёт меня» и поручения',
    modules: ['inbox'],
    items: [
      'Все согласования, проверки и оплаты, которые сейчас за вами, — одним списком со сроком и кнопкой действия; число дел — в меню.',
      'Поручения сотрудникам: что сделать, срок, проект; выдавший видит выполнение.',
    ],
  },
  {
    id: '2026-10-16-card',
    at: '2026-10-16T18:35:00Z',
    title: 'Регистрация проекта по Регламенту № 33П',
    modules: ['portfolio'],
    items: [
      'Вкладка «Карточка проекта»: запрос заказчика, ТЗ, расчёт себестоимости с подтверждением исполнителя и ПТО, КП заказчику.',
      'Условия финансирования: кредиты и банковские гарантии со стоимостью за период.',
      'До подписания доходного договора заявки и расходные договоры не создаются, кроме случая служебной записки, одобренной Директором.',
      'Карточка проекта по форме приложения 1 к приказу № 29П с выгрузкой в Excel; после подписания договора — задача РП на карточку и ФП за 5 рабочих дней.',
    ],
  },
  {
    id: '2026-10-16-payments',
    at: '2026-10-16T18:14:00Z',
    title: 'Реестры закупок и заявки на оплату',
    modules: ['procurement', 'contracts', 'finance'],
    items: [
      'Подписанный договор переводит заявку в «Готово к реестру»; реестр формируется в Excel.',
      'Заявки на оплату по типу платежа — аванс, промежуточный, окончательный — с комплектом документов; оплата сверх договора — только через согласование.',
      'Отметка «Оплачено» попадает в проект и финансовый план; номера и статусы 1С вносятся вручную.',
      'Экран руководителя закупок: заявки по этапам, просрочки, суммы; поиск по номеру, материалу, поставщику, договору и реестру.',
    ],
  },
  {
    id: '2026-10-16-finplan',
    at: '2026-10-16T18:00:00Z',
    title: 'Финансовый план проекта',
    modules: ['budget'],
    items: [
      'Форма по приложению 2 к приказу № 29П: двенадцать статей, план и факт по месяцам, баланс проекта и стоимость отрицательного баланса.',
      'Маршрут: руководитель проекта → ПТО → финансовый менеджер → куратор; каждое изменение — новая версия.',
      'В заявке на закуп виден остаток статьи утверждённого ФП; сверх остатка заявка не идёт дальше проверки.',
    ],
  },
  {
    id: '2026-10-16-contracts',
    at: '2026-10-16T17:45:00Z',
    title: 'Договоры',
    modules: ['contracts'],
    items: [
      'Договор из выбранного КП: спецификация и условия подставляются сами.',
      'Маршрут из пяти согласующих по Регламенту № 33П со сроком 2 рабочих дня; подписание — только после маршрута.',
      'Карточка договора подтверждается руководителем проекта; номер и дата регистрации в 1С.',
    ],
  },
  {
    id: '2026-10-16-procurement',
    at: '2026-10-16T17:38:00Z',
    title: 'Закупки',
    modules: ['procurement'],
    items: [
      'Заявки на закуп с этапами и сроками, доска заявок, КП поставщиков и сравнение со сметой.',
      'Выбор поставщика с пояснением по приказу № 31П; не меньше трёх КП или обоснование.',
    ],
  },
  {
    id: '2026-10-16-portfolio',
    at: '2026-10-16T17:28:00Z',
    title: 'Портфель и проекты',
    modules: ['portfolio'],
    items: [
      'Компания → направление → проект → подпроект → объект; своды по портфелю.',
      'Бюджет-график с импортом из Excel и утверждением; блок «Требует внимания».',
      'Пилот — площадка Карабатан, договор 227-23.',
    ],
  },
  {
    id: '2026-10-16-platform',
    at: '2026-10-16T16:23:00Z',
    title: 'Платформа',
    modules: [],
    items: [
      'Вход по паролю и по Face ID, Touch ID и Windows Hello.',
      'Роли по компании, юрлицу и проекту; уровень доступа к деньгам выдаётся человеку.',
      'История «кто, что, когда, было → стало» по каждой записи.',
      'Оформление по брендбуку EPC Pilot AI.',
    ],
  },
];
